import propTypes from 'prop-types'

export const ArrowLeftIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
</svg>)

export const DownloadIcon = (props) => (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" {...props}>
  <path strokeLinecap="round" stroke="#5473E3" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
</svg>)

export const DownArrowIcon = (props) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  {...props}
>
  <path
    d="M12 6V18"
    stroke="#5974D8"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M6.5 12.5L12 18L17.5 12.5"
    stroke="#5974D8"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
)

export const DownloadActiveIcon = (props) => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="17"
  height="16"
  fill="none"
  viewBox="0 0 17 16"
  {...props}
>
  <path
    stroke="#5473E3"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M14.5 10v2.667A1.334 1.334 0 0 1 13.167 14H3.833A1.334 1.334 0 0 1 2.5 12.667V10M5.167 6.667 8.5 10l3.333-3.333M8.5 10V2"
  ></path>
</svg>)

export const GreytHrProLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="146"
    height="55"
    fill="none"
    viewBox="0 0 146 55"
  >
    <path
      fill="#AA00EA"
      d="M112.311 55c-5.538 0-6.66-7.836-1.343-9.389l26.46-7.73c3.81-1.112 7.621 1.745 7.621 5.714v5.453A5.952 5.952 0 01139.097 55h-26.786z"
    ></path>
    <path
      fill="#fff"
      d="M126.469 47.376c0 .39-.094.754-.281 1.094-.181.34-.469.614-.865.823-.389.208-.882.312-1.479.312h-1.219v2.792h-1.458v-7.27h2.677c.563 0 1.042.096 1.438.29.395.195.691.463.885.803.201.34.302.726.302 1.156zm-2.687 1.052c.402 0 .701-.09.895-.27.195-.188.292-.449.292-.782 0-.708-.396-1.062-1.187-1.062h-1.157v2.114h1.157zm7.472 3.969l-1.604-2.833h-.687v2.833h-1.459v-7.27h2.73c.562 0 1.041.1 1.437.301.396.195.691.462.885.802.202.334.303.709.303 1.125 0 .48-.139.914-.417 1.302-.278.382-.691.646-1.24.792l1.74 2.948h-1.688zm-2.291-3.927h1.219c.395 0 .69-.094.885-.281.194-.195.292-.462.292-.802 0-.334-.098-.59-.292-.771-.195-.188-.49-.282-.885-.282h-1.219v2.136zm8.59 4c-.681 0-1.306-.16-1.875-.48a3.592 3.592 0 01-1.355-1.322c-.333-.57-.5-1.212-.5-1.927 0-.709.167-1.344.5-1.907a3.569 3.569 0 011.355-1.333 3.764 3.764 0 011.875-.479c.687 0 1.312.16 1.875.48a3.49 3.49 0 011.343 1.332c.334.563.5 1.198.5 1.907 0 .715-.166 1.357-.5 1.927a3.51 3.51 0 01-1.343 1.323 3.77 3.77 0 01-1.875.479zm0-1.302c.437 0 .822-.097 1.156-.292.333-.201.594-.486.781-.854.188-.368.281-.795.281-1.281 0-.486-.093-.91-.281-1.271a2 2 0 00-.781-.844 2.254 2.254 0 00-1.156-.291c-.438 0-.827.097-1.167.291a2 2 0 00-.781.844c-.188.361-.282.785-.282 1.27 0 .487.094.914.282 1.282.187.368.448.653.781.854.34.195.729.292 1.167.292z"
    ></path>
    <mask
      id="mask0_10452_52840"
      style={{ maskType: "luminance" }}
      width="114"
      height="55"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth="0.315"
        d="M.157.157h113.621v53.805H.158V.157z"
      ></path>
    </mask>
    <g mask="url(#mask0_10452_52840)">
      <path
        fill="#AA00EA"
        stroke="#AA00EA"
        strokeWidth="0.315"
        d="M45.054 25.593a3.909 3.909 0 01-3.908 3.914 3.909 3.909 0 01-3.908-3.914 3.909 3.909 0 117.816 0zM106.899 4.07a3.91 3.91 0 01-3.908 3.914 3.91 3.91 0 01-3.908-3.913 3.91 3.91 0 013.908-3.914 3.91 3.91 0 013.908 3.914zM77.467 14.313a3.909 3.909 0 11-7.815 0 3.909 3.909 0 117.815 0zM94.505 48.85v-2.925h1.619v7.604h-1.619v-3.13H90.86v3.13h-1.63v-7.604h1.63v3.082h3.645v-.157z"
      ></path>
      <mask id="path-8-inside-1_10452_52840" fill="#fff">
        <path d="M100.141 50.966h-.566v2.72h-1.946v-7.918h3.999c1.711 0 2.843 1.043 2.843 2.587 0 1.303-.801 2.231-2.078 2.515l2.475 2.81h-2.349l-2.384-2.72.006.006zm2.421-2.587c0-.567-.446-.947-1.145-.947h-1.842v1.9h1.842c.699 0 1.145-.38 1.145-.959"></path>
      </mask>
      <path
        fill="#AA00EA"
        d="M100.141 50.966h-.566v2.72h-1.946v-7.918h3.999c1.711 0 2.843 1.043 2.843 2.587 0 1.303-.801 2.231-2.078 2.515l2.475 2.81h-2.349l-2.384-2.72.006.006zm2.421-2.587c0-.567-.446-.947-1.145-.947h-1.842v1.9h1.842c.699 0 1.145-.38 1.145-.959"
      ></path>
      <path
        fill="#AA00EA"
        d="M100.141 50.966v.315h.758l-.536-.537-.222.222zm-.566 0v-.314h-.315v.314h.315zm0 2.72v.315h.314v-.315h-.314zm-1.946 0h-.314v.315h.314v-.315zm0-7.918v-.315h-.314v.315h.314zm4.764 5.102l-.068-.307-.52.115.352.4.236-.208zm2.475 2.81v.315h.697l-.461-.523-.236.208zm-2.349 0l-.236.208.094.107h.142v-.315zm-2.384-2.72l.222-.222-.459.43.237-.208zm-.56-3.528v-.314h-.315v.314h.315zm0 1.9h-.315v.315h.315v-.315zm.566 1.32h-.566v.629h.566v-.63zm-.881.314v2.72h.63v-2.72h-.63zm.315 2.405h-1.946v.63h1.946v-.63zm-1.631.315v-7.918h-.63v7.918h.63zm-.315-7.604h3.999v-.629h-3.999v.63zm3.999 0c.792 0 1.422.241 1.851.633.426.39.677.949.677 1.64h.629c0-.853-.315-1.587-.882-2.105-.565-.516-1.356-.797-2.275-.797v.63zm2.528 2.273c0 .584-.178 1.069-.487 1.438-.309.37-.764.64-1.344.77l.136.614c.696-.155 1.281-.49 1.691-.98.411-.493.633-1.124.633-1.842h-.629zm-1.999 2.723l2.475 2.81.472-.416-2.475-2.81-.472.416zm2.711 2.287h-2.349v.63h2.349v-.63zm-2.112.108l-2.385-2.72-.473.415 2.385 2.72.473-.415zm-2.844-2.29l.006.005.445-.444-.006-.006-.445.444zm2.964-2.804c0-.372-.149-.7-.423-.927-.268-.224-.632-.334-1.036-.334v.629c.295 0 .504.08.633.188.124.103.197.25.197.444h.629zm-1.459-1.261h-1.842v.629h1.842v-.63zm-2.157.314v1.9h.63v-1.9h-.63zm.315 2.215h1.842v-.63h-1.842v.63zm1.842 0c.404 0 .768-.11 1.037-.337.274-.23.422-.56.422-.937h-.629a.568.568 0 01-.198.456c-.129.108-.337.188-.632.188v.63z"
        mask="url(#path-8-inside-1_10452_52840)"
      ></path>
      <mask id="path-10-inside-2_10452_52840" fill="#fff">
        <path d="M58.344 21.523c-6.19 0-11.28 4.583-11.28 11.295s5.09 11.295 11.238 11.295c4.878 0 8.732-2.165 10.557-6.663l-6.022-1.23c-1.144 2.08-2.97 2.46-4.535 2.46-2.288 0-4.029-1.574-4.577-4.12H69.33v-1.742c-.127-6.96-4.962-11.295-10.979-11.295m-4.492 8.87c.638-2.164 2.59-3.352 4.492-3.352 1.903 0 3.65 1.06 4.282 3.353h-8.774z"></path>
      </mask>
      <path
        fill="#AA00EA"
        d="M58.344 21.523c-6.19 0-11.28 4.583-11.28 11.295s5.09 11.295 11.238 11.295c4.878 0 8.732-2.165 10.557-6.663l-6.022-1.23c-1.144 2.08-2.97 2.46-4.535 2.46-2.288 0-4.029-1.574-4.577-4.12H69.33v-1.742c-.127-6.96-4.962-11.295-10.979-11.295m-4.492 8.87c.638-2.164 2.59-3.352 4.492-3.352 1.903 0 3.65 1.06 4.282 3.353h-8.774z"
      ></path>
      <path fill="#AA00EA" d="M68.86 37.45l.29.118.143-.351-.371-.076-.063.309zm-6.023-1.23l.063-.309-.227-.046-.112.203.276.151zm-9.112-1.66v-.314h-.39l.082.381.308-.066zm15.604 0v.315h.314v-.314h-.314zm0-1.742h.315v-.006l-.315.006zm-15.471-2.424l-.302-.09-.12.404h.422v-.314zm8.774 0v.314h.413l-.11-.398-.303.084zm-4.288-9.186c-6.355 0-11.594 4.715-11.594 11.61h.63c0-6.53 4.938-10.98 10.964-10.98v-.63zM46.75 32.818c0 6.894 5.238 11.61 11.552 11.61v-.63c-5.983 0-10.923-4.45-10.923-10.98h-.63zm11.552 11.61c4.984 0 8.968-2.223 10.849-6.86l-.584-.237C66.8 41.691 63.074 43.8 58.302 43.8v.629zm10.62-7.287l-6.022-1.23-.126.617 6.022 1.23.126-.617zm-6.36-1.073c-1.066 1.936-2.748 2.297-4.26 2.297v.63c1.62 0 3.587-.4 4.81-2.624l-.55-.303zm-4.26 2.297c-2.112 0-3.746-1.44-4.27-3.87l-.614.132c.572 2.66 2.42 4.367 4.884 4.367v-.629zm-4.577-3.49H69.33v-.629H53.725v.63zm15.918-.314v-1.743h-.629v1.743h.63zm0-1.749c-.13-7.129-5.103-11.604-11.293-11.604v.63c5.843 0 10.54 4.196 10.664 10.986l.63-.012zm-15.484-2.33c.595-2.017 2.413-3.127 4.191-3.127v-.63c-2.027 0-4.112 1.267-4.794 3.58l.603.178zm4.191-3.127c1.772 0 3.387.976 3.979 3.122l.606-.167c-.672-2.438-2.55-3.584-4.585-3.584v.63zm4.282 2.724h-8.774v.63h8.774v-.63z"
        mask="url(#path-10-inside-2_10452_52840)"
      ></path>
      <path fill="#AA00EA" stroke="#AA00EA" strokeWidth="0.315" d="M81.681 53.515h-6.95l4.614-10.69.027-.062-.026-.062-8.705-20.375h6.948l4.99 12.3.14.348.15-.344 5.324-12.304h11.448v-.152h.157v-6.977h6.466V22.332h6.275v5.076h-6.275v7.545c0 1.127.271 1.948.798 2.488.528.54 1.286.77 2.202.77.902 0 2.1-.304 3-.776l1.48 5.039c-1.607.854-3.292 1.489-5.624 1.489-2.622 0-4.698-.715-6.117-2.1-1.419-1.385-2.205-3.462-2.205-6.234v-8.227h-6.849l-.041.095L81.68 53.515zM34.895 40.124v3.202h-6.473V22.328h6.473v17.796zM16.896 23.973l.262.236v-1.896h6.473v21.583c0 3.243-1.375 5.745-3.6 7.44-2.229 1.7-5.32 2.595-8.751 2.595C6.503 53.93 2.91 52.29.855 49l5.387-3.325c.756.904 1.449 1.545 2.224 1.962.808.435 1.693.619 2.814.619 1.55 0 3.017-.389 4.1-1.217 1.09-.833 1.778-2.102 1.778-3.825V41.42l-.262.236c-1.618 1.455-3.784 2.294-6.508 2.294-5.543 0-10.23-4.512-10.23-11.138 0-6.627 4.687-11.138 10.23-11.132h0c2.718 0 4.89.839 6.508 2.293zm-9.29 8.845a4.224 4.224 0 004.222 4.228 4.224 4.224 0 004.222-4.228 4.224 4.224 0 10-8.445 0z"
      ></path>
    </g>
  </svg>

)

export const HelloHandIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="25"
  height="25"
  fill="none"
  viewBox="0 0 25 25"
>
  <g clipPath="url(#clip0_940_8408)">
    <mask
      id="mask0_940_8408"
      style={{ maskType: "luminance" }}
      width="25" height="25" x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M.25.232h24v24h-24v-24z"></path>
    </mask>
    <g mask="url(#mask0_940_8408)">
      <path
        fill="#E69C1E"
        d="M21.916 11.813s.715-1.042-.327-1.756c-1.042-.715-1.756.327-1.756.327l-3.317 4.837a6.495 6.495 0 00-.378-.565l4.603-6.713s.714-1.041-.328-1.755c-1.041-.715-1.756.327-1.756.327l-4.33 6.314a16.966 16.966 0 00-.495-.393l5.019-7.32s.714-1.042-.327-1.756c-1.042-.715-1.756.327-1.756.327l-5.02 7.32c-.184-.114-.367-.212-.55-.315l4.691-6.841s.715-1.042-.328-1.756c-1.041-.715-1.755.327-1.755.327l-4.96 7.234-.398.58-.357.52c3.125 2.143 3.423 6.177 1.637 8.78-.357.522-.878.165-.878.165 2.143-3.126 1.488-6.638-1.637-8.78l.923-4.613s.344-1.215-.871-1.56c-1.215-.344-1.56.871-1.56.871L4.642 8.78c-.421 1.254-.87 2.502-1.465 3.683a7.58 7.58 0 0013.026 7.686c.125-.184.23-.362.33-.541l.027.02 5.357-7.814z"
      ></path>
      <path
        fill="#05A2AD"
        d="M2.171 5.285H.908A4.4 4.4 0 015.303.891v1.263A3.135 3.135 0 002.17 5.285"
      ></path>
      <path
        fill="#05A2AD"
        d="M3.408 8.442H2.145a6.323 6.323 0 016.316-6.315V3.39a5.059 5.059 0 00-5.053 5.052zM19.197 23.6v-1.263c1.895 0 3.158-1.263 3.158-3.157h1.263c0 2.526-1.894 4.42-4.42 4.42z"
      ></path>
      <path
        fill="#05A2AD"
        d="M16.04 22.364v-1.263c2.526 0 5.079-2.553 5.079-5.08h1.263c0 3.79-2.553 6.343-6.342 6.343z"
      ></path>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_940_8408">
      <path
        fill="#fff"
        d="M0 0H24V24H0z"
        transform="translate(.25 .232)"
      ></path>
    </clipPath>
  </defs>
</svg>)

export const GoogleLogo = () => (<svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
  <g clipPath="url(#clip0_317_5410)">
    <path fill="#4285F4" d="M17.99 9.297c0-.738-.06-1.276-.193-1.834H9.18v3.328h5.058c-.102.828-.653 2.073-1.877 2.91l-.017.112 2.725 2.062.189.019c1.733-1.565 2.733-3.867 2.733-6.597z" ></path>
    <path fill="#34A853" d="M9.18 18.066c2.478 0 4.558-.797 6.078-2.172L12.362 13.7c-.775.528-1.816.897-3.182.897a5.514 5.514 0 01-5.222-3.727l-.107.009-2.833 2.143-.038.1c1.51 2.93 4.61 4.943 8.2 4.943z"  ></path>
    <path fill="#FBBC05" d="M3.959 10.871a5.408 5.408 0 01-.306-1.774c0-.618.112-1.216.296-1.774l-.006-.119-2.868-2.177-.094.044a8.811 8.811 0 00-.979 4.026c0 1.445.357 2.81.979 4.026l2.978-2.252z" ></path>
    <path fill="#EB4335" d="M9.18 3.596c1.723 0 2.886.727 3.549 1.335l2.59-2.471C13.73 1.015 11.658.128 9.18.128 5.59.128 2.49 2.14.98 5.07l2.968 2.252A5.537 5.537 0 019.18 3.596z" ></path>
  </g>
  <defs>
    <clipPath id="clip0_317_5410">
      <path fill="#fff" d="M0 0H18V18H0z" transform="translate(0 .128)" ></path>
    </clipPath>
  </defs>
</svg>)

export const PlusRoundedIcon = ({ className, style }) => (<svg style={style} className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#EDF3FF" strokeLinecap="round" strokeLinejoin="round" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8v8M8 12h8"></path>
</svg>)

export const PlusRoundedIconBlue = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    stroke="#5473E3"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M10 18.334a8.333 8.333 0 100-16.667 8.333 8.333 0 000 16.667zM10 6.667v6.667M6.667 10h6.667"
  ></path>
</svg>)

export const CompanyPicIcon = () => (<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="40" height="40" rx="20" fill="#A3B3C8" />
  <g clipPath="url(#clip0_2_252)">
    <path fillRule="evenodd" clipRule="evenodd" d="M11.9822 12.2398C12.6781 11.764 13.5072 11.506 14.3585 11.5004C14.9986 11.5004 15.9245 11.6746 16.7348 12.2398C17.6247 12.8611 18.2617 13.8854 18.2617 15.2886C18.2617 16.6918 17.6247 17.7146 16.7348 18.3359C16.039 18.8123 15.2099 19.0708 14.3585 19.0768C13.7184 19.0768 12.7925 18.9026 11.9822 18.3359C11.0923 17.7146 10.4553 16.6933 10.4553 15.2886C10.4553 13.8854 11.0923 12.8626 11.9822 12.2398ZM26.5207 35.4795C30.0804 34.3172 35.327 30.1551 36.5397 21.6398C36.5397 21.2379 36.5397 20.0004 36.5397 19.5207C36.2469 19.2365 35.8498 19.0768 35.4357 19.0768H33.8745C26.3756 19.0768 21.0564 20.7012 17.3952 23.05C20.5724 24.0531 23.7589 25.8078 26.1852 28.7338C26.4448 29.0473 26.5655 29.448 26.5207 29.8479C26.4759 30.2477 26.2693 30.6139 25.9463 30.8659C25.6233 31.1178 25.2104 31.235 24.7985 31.1915C24.3865 31.148 24.0092 30.9475 23.7496 30.634C21.3842 27.7792 18.0509 26.2215 14.7004 25.4669C12.8922 25.066 11.0423 24.8687 9.18754 24.8789C7.9635 24.8835 6.88153 24.9789 6.02751 25.1168C5.9079 25.1364 5.78635 25.1425 5.66529 25.135L5.51541 25.1592C5.28398 25.1968 5.06424 25.2844 4.87252 25.4157C4.68079 25.547 4.52202 24.5042 4.40801 24.7033C4.294 24.9023 4.22767 25.1237 4.21397 25.351C4.20026 25.5784 4.32029 26.1674 4.4096 26.378C5.42756 28.7783 8.39771 32.4898 12.1057 34.5718C15.884 36.6917 20.1803 37.7403 26.5207 35.4795Z" fill="#F7F7F7" />
    <path d="M20.0002 36.1912C28.9419 36.1912 36.1907 28.9425 36.1907 20.0007C36.1907 11.059 28.9419 3.81027 20.0002 3.81027C11.0584 3.81027 3.80971 11.059 3.80971 20.0007C3.80971 28.9425 11.0584 36.1912 20.0002 36.1912Z" stroke="#F7F7F7" strokeWidth="1.61905" strokeLinecap="round" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_2_252">
      <rect width="34" height="34" fill="white" transform="translate(3 3)" />
    </clipPath>
  </defs>
</svg>)

export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.333 2.5H2.5v5.833h5.833V2.5zM17.5 2.5h-5.833v5.833H17.5V2.5zM17.5 11.667h-5.833V17.5H17.5v-5.833zM8.333 11.667H2.5V17.5h5.833v-5.833z"
    ></path>
  </svg>
)

export const DashboardIconPrimary500 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" d="M8.333 2.5H2.5v5.833h5.833V2.5zM17.5 2.5h-5.833v5.833H17.5V2.5zM17.5 11.667h-5.833V17.5H17.5v-5.833zM8.333 11.667H2.5V17.5h5.833v-5.833z"></path>
  </svg>
)

export const TeamsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-users"
    viewBox="0 0 24 24" {...props}
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
)

export const TeamsIconPrimary500 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" >
    <path stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" d="M15.833 2.5H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667z" ></path>
    <path stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" d="M8.333 5.833h-2.5v7.5h2.5v-7.5zM14.167 5.833h-2.5V10h2.5V5.833z" ></path>
  </svg>
)


export const ClientsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.667 5.833H3.334c-.92 0-1.667.747-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667h13.333c.92 0 1.667-.746 1.667-1.667V7.5c0-.92-.747-1.667-1.667-1.667z"
    ></path>
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.334 17.5V4.167A1.667 1.667 0 0011.667 2.5H8.334a1.667 1.667 0 00-1.667 1.667V17.5"
    ></path>
  </svg>
)

export const ClientsIconPrimary500 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" d="M16.667 5.833H3.334c-.92 0-1.667.746-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667h13.333c.92 0 1.667-.747 1.667-1.667V7.5c0-.92-.747-1.667-1.667-1.667z"></path>
    <path stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" d="M13.334 17.5V4.167A1.667 1.667 0 0011.667 2.5H8.334a1.667 1.667 0 00-1.667 1.667V17.5"></path>
  </svg>
)


export const HelpDeskIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.5 11.667l8.333-10L10 8.333h7.5l-8.333 10L10 11.667H2.5z"
    ></path>
  </svg>
)
export const HelpDeskIconPrimary500 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" >
    <path stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" d="M2.5 11.667l8.333-10L10 8.334h7.5l-8.333 10L10 11.667H2.5z" ></path>
  </svg>
)

export const NewsAlertsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.833 2.5H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667zM2.5 7.5h15M7.5 17.5v-10"
    ></path>
  </svg>

)

export const NewsAlertsIconPrimary500 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" >
    <path stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" d="M15.833 2.5H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667zM2.5 7.5h15M7.5 17.5v-10" ></path>
  </svg>
)

export const CustomersIcon = () => (<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.6364 17.0782V15.6237C13.6364 14.8521 13.3299 14.1122 12.7843 13.5666C12.2388 13.0211 11.4988 12.7146 10.7273 12.7146H4.90909C4.13755 12.7146 3.39761 13.0211 2.85205 13.5666C2.30649 14.1122 2 14.8521 2 15.6237V17.0782M18 17.0782V15.6237C17.9995 14.9791 17.785 14.353 17.3901 13.8435C16.9952 13.3341 16.4423 12.9703 15.8182 12.8091M12.9091 4.08185C13.5348 4.24207 14.0895 4.606 14.4856 5.11626C14.8816 5.62652 15.0966 6.25409 15.0966 6.90003C15.0966 7.54597 14.8816 8.17354 14.4856 8.68381C14.0895 9.19407 13.5348 9.558 12.9091 9.71821M10.7273 6.8964C10.7273 8.50304 9.42483 9.80549 7.81818 9.80549C6.21154 9.80549 4.90909 8.50304 4.90909 6.8964C4.90909 5.28975 6.21154 3.9873 7.81818 3.9873C9.42483 3.9873 10.7273 5.28975 10.7273 6.8964Z" stroke="#394657" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>)

export const AuditLogIcon = () => (<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 6.36654C10 5.48248 9.66286 4.63463 9.06274 4.00951C8.46263 3.38439 7.64869 3.0332 6.8 3.0332H2V15.5332H7.6C8.23652 15.5332 8.84697 15.7966 9.29706 16.2654C9.74714 16.7343 10 17.3702 10 18.0332M10 6.36654V18.0332M10 6.36654C10 5.48248 10.3371 4.63463 10.9373 4.00951C11.5374 3.38439 12.3513 3.0332 13.2 3.0332H18V15.5332H12.4C11.7635 15.5332 11.153 15.7966 10.7029 16.2654C10.2529 16.7343 10 17.3702 10 18.0332" stroke="#394657" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
</svg>)

export const ViewIcon = (props) => (<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"{...props} >
  <g clipPath="url(#clip0_714_2213)">
    <path d="M10.9953 3.33337C5.16195 3.33337 1.82861 10 1.82861 10C1.82861 10 5.16195 16.6667 10.9953 16.6667C16.8286 16.6667 20.1619 10 20.1619 10C20.1619 10 16.8286 3.33337 10.9953 3.33337Z" stroke="#5473E3" strokeLinejoin="round" />
    <path d="M10.9956 12.5C12.3763 12.5 13.4956 11.3807 13.4956 10C13.4956 8.61929 12.3763 7.5 10.9956 7.5C9.61489 7.5 8.49561 8.61929 8.49561 10C8.49561 11.3807 9.61489 12.5 10.9956 12.5Z" stroke="#5473E3" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_714_2213">
      <rect width="20" height="20" fill="white" transform="translate(0.995605)" />
    </clipPath>
  </defs>
</svg>)

export const EyeOffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" >
    <g stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#clip0_2086_53340)">
      <path d="M14.95 14.95A8.391 8.391 0 0110 16.667C4.166 16.667.833 10 .833 10A15.375 15.375 0 015.05 5.05m3.2-1.517a7.6 7.6 0 011.75-.2c5.833 0 9.166 6.667 9.166 6.667a15.414 15.414 0 01-1.8 2.658m-5.6-.891a2.5 2.5 0 11-3.533-3.534M.833.833l18.333 18.334"></path>
    </g>
    <defs>
      <clipPath id="clip0_2086_53340">
        <path fill="#fff" d="M0 0H20V20H0z"></path>
      </clipPath>
    </defs>
  </svg>
)

export const LoginIcon = (props) => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.4971 2.5H16.8304C17.2724 2.5 17.6964 2.67559 18.0089 2.98816C18.3215 3.30072 18.4971 3.72464 18.4971 4.16667V15.8333C18.4971 16.2754 18.3215 16.6993 18.0089 17.0118C17.6964 17.3244 17.2724 17.5 16.8304 17.5H13.4971M9.33008 14.1666L13.4967 9.99992M13.4967 9.99992L9.33008 5.83325M13.4967 9.99992L3.49707 10" stroke="#5473E3" strokeLinejoin="round" />
  </svg>
)

export const DisableIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="33"
  height="32"
  fill="none"
  viewBox="0 0 33 32"
>
  <path
    stroke="#5473E3"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M11.107 10.108l11.784 11.784M25.331 16a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0z"
  ></path>
</svg>)
export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    fill="none"
    viewBox="0 0 33 32"
  >
    <path
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.164 9.334h-5.833A1.667 1.667 0 008.664 11v11.667a1.666 1.666 0 001.667 1.666h11.666a1.667 1.667 0 001.667-1.666v-5.834"
    ></path>
    <path
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M23.664 7.565c-.469 0-.918.187-1.25.518L14.497 16l-.833 3.333 3.333-.833 7.917-7.917a1.768 1.768 0 00-1.25-3.018z"
    ></path>
  </svg>
)
EditIcon.defaultProps = {
  width: "33",
  height: "32"
}

export const SortIcon = () => (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.46734 3.3L5.54362 4.24267L3.88693 2.552V11.3333H2.5804V2.552L0.924372 4.24267L0 3.3L3.23367 0L6.46734 3.3ZM13 8.7L9.76633 12L6.53266 8.7L7.45638 7.75733L9.11372 9.448L9.11306 0.666667H10.4196V9.448L12.0763 7.75733L13 8.7Z" fill="#677A8E" />
  </svg>
)
export const SortUpIcon = () => (<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.46734 3.3L5.54362 4.24267L3.88693 2.552V11.3333H2.5804V2.552L0.924372 4.24267L0 3.3L3.23367 0L6.46734 3.3Z" fill="#1D378C" />
  <path d="M9.23367 11.3333L12.4673 8.03333L11.5436 7.09067L9.88693 8.78133V0H8.5804L8.58105 8.78133L6.92372 7.09067L6 8.03333L9.23367 11.3333Z" fill="#677A8E" />
</svg>
)
export const SortDownIcon = () => (<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.46734 3.3L5.54362 4.24267L3.88693 2.552V11.3333H2.5804V2.552L0.924372 4.24267L0 3.3L3.23367 0L6.46734 3.3Z" fill="#5473E3" />
  <path d="M9.23367 11.3333L12.4673 8.03333L11.5436 7.09067L9.88693 8.78133V0H8.5804L8.58105 8.78133L6.92372 7.09067L6 8.03333L9.23367 11.3333Z" fill="#1D378C" />
</svg>
)

export const PaginationFirstIcon = () => (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.7267 12L12.6667 11.06L9.61333 8L12.6667 4.94L11.7267 4L7.72667 8L11.7267 12Z" fill="#394657" />
  <path d="M7.33332 12L8.27332 11.06L5.21998 8L8.27332 4.94L7.33332 4L3.33332 8L7.33332 12Z" fill="#394657" />
</svg>)

export const PaginationLastIcon = () => (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.27333 4L3.33333 4.94L6.38667 8L3.33333 11.06L4.27333 12L8.27333 8L4.27333 4Z" fill="#394657" />
  <path d="M8.66667 4L7.72667 4.94L10.78 8L7.72667 11.06L8.66667 12L12.6667 8L8.66667 4Z" fill="#394657" />
</svg>)

export const SearchIcon = () => (<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_727_1534)">
    <path d="M4.58333 7.91667C6.42428 7.91667 7.91667 6.42428 7.91667 4.58333C7.91667 2.74238 6.42428 1.25 4.58333 1.25C2.74238 1.25 1.25 2.74238 1.25 4.58333C1.25 6.42428 2.74238 7.91667 4.58333 7.91667Z" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.75 8.75L6.9375 6.9375" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_727_1534">
      <rect width="10" height="10" fill="white" />
    </clipPath>
  </defs>
</svg>)


export const InfoIcon = (props) => (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <g clip-path="url(#clip0_1908_4742)">
    <path d="M8 14.6673C11.6819 14.6673 14.6667 11.6825 14.6667 8.00065C14.6667 4.31875 11.6819 1.33398 8 1.33398C4.3181 1.33398 1.33333 4.31875 1.33333 8.00065C1.33333 11.6825 4.3181 14.6673 8 14.6673Z" stroke="#677A8E" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M8 10.6667V8" stroke="#677A8E" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M8 5.33398H8.00667" stroke="#677A8E" stroke-linecap="round" stroke-linejoin="round"></path>
  </g>
  <defs>
    <clipPath id="clip0_1908_4742">
      <rect width="16" height="16" fill="white"></rect>
    </clipPath>
  </defs>
</svg>)

export const CloseIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
</svg>)

export const CircleSuccessIcon = () => (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.00033 17.3337C13.6027 17.3337 17.3337 13.6027 17.3337 9.00033C17.3337 4.39795 13.6027 0.666992 9.00033 0.666992C4.39795 0.666992 0.666992 4.39795 0.666992 9.00033C0.666992 13.6027 4.39795 17.3337 9.00033 17.3337Z" stroke="#48A84D" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M12.8098 6.5L7.89914 11.5L5.66699 9.22727" stroke="#48A84D" strokeLinecap="round" strokeLinejoin="round" />
</svg>)

export const CircleWarningIcon = () => (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.00033 17.3337C13.6027 17.3337 17.3337 13.6027 17.3337 9.00033C17.3337 4.39795 13.6027 0.666992 9.00033 0.666992C4.39795 0.666992 0.666992 4.39795 0.666992 9.00033C0.666992 13.6027 4.39795 17.3337 9.00033 17.3337Z" stroke="#F2B13F" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M9 5.66699V9.00033" stroke="#F2B13F" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M9 12.333H9.00833" stroke="#F2B13F" strokeLinecap="round" strokeLinejoin="round" />
</svg>)

export const CircleErrorIcon = () => (<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.33333 17.6667C13.9357 17.6667 17.6667 13.9357 17.6667 9.33333C17.6667 4.73096 13.9357 1 9.33333 1C4.73096 1 1 4.73096 1 9.33333C1 13.9357 4.73096 17.6667 9.33333 17.6667Z" stroke="#F05454" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M9.33301 6V9.33333" stroke="#F05454" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M9.33301 12.666H9.34134" stroke="#F05454" strokeLinecap="round" strokeLinejoin="round" />
</svg>)



export const CloseRoundedIcon = (props) => (<svg width="24" height="24" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M11 20.1666C16.0626 20.1666 20.1667 16.0626 20.1667 11C20.1667 5.93737 16.0626 1.83331 11 1.83331C5.9374 1.83331 1.83334 5.93737 1.83334 11C1.83334 16.0626 5.9374 20.1666 11 20.1666Z" stroke="#677A8E" strokeLinejoin="round" />
  <path d="M13.75 8.25L8.25 13.75" stroke="#677A8E" strokeLinejoin="round" />
  <path d="M8.25 8.25L13.75 13.75" stroke="#677A8E" strokeLinejoin="round" />
</svg>)

export const CloseRoundedIconPrimary = () => (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#5473E3" strokeLinecap="round" strokeLinejoin="round" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM15 9l-6 6M9 9l6 6"></path>
</svg>)

export const CloseSquareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" > <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M15.833 2.5H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667zM7.5 7.5l5 5M12.5 7.5l-5 5" ></path> </svg>
)

export const SaveIcon = () => (<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.1667 18V11.3333H5.83333V18M5.83333 3V7.16667H12.5M15.8333 18H4.16667C3.72464 18 3.30072 17.8244 2.98816 17.5118C2.67559 17.1993 2.5 16.7754 2.5 16.3333V4.66667C2.5 4.22464 2.67559 3.80072 2.98816 3.48816C3.30072 3.17559 3.72464 3 4.16667 3H13.3333L17.5 7.16667V16.3333C17.5 16.7754 17.3244 17.1993 17.0118 17.5118C16.6993 17.8244 16.2754 18 15.8333 18Z" stroke="white" strokeLinejoin="round" />
</svg>)

export const BackArrowIcon = () => (<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.93958 19.716L0.464458 11.0252C0.336047 10.8936 0.244875 10.7509 0.190943 10.5973C0.137866 10.4437 0.111328 10.2791 0.111328 10.1035C0.111328 9.92791 0.137866 9.76332 0.190943 9.60969C0.244875 9.45607 0.336047 9.31341 0.464458 9.18173L8.93958 0.490927C9.175 0.249515 9.46906 0.123104 9.82176 0.111692C10.1753 0.101157 10.4805 0.227569 10.7373 0.490927C10.9942 0.732338 11.1281 1.03388 11.1393 1.39556C11.1495 1.75812 11.0263 2.07107 10.7694 2.33443L4.4773 8.7867H18.8272C19.1911 8.7867 19.4962 8.91267 19.7428 9.16462C19.9885 9.41744 20.1113 9.7304 20.1113 10.1035C20.1113 10.4766 19.9885 10.7891 19.7428 11.041C19.4962 11.2939 19.1911 11.4203 18.8272 11.4203H4.4773L10.7694 17.8725C11.0049 18.114 11.1281 18.4212 11.1393 18.7943C11.1495 19.1674 11.0263 19.4746 10.7694 19.716C10.534 19.9794 10.2344 20.1111 9.87056 20.1111C9.50673 20.1111 9.1964 19.9794 8.93958 19.716Z" fill="#677A8E" />
</svg>)

export const FilterIcon = (props) => (<svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M1.66675 3H18.3334L11.6667 10.8833V18L8.33342 16.3333V10.8833L1.66675 3Z" stroke="#5473E3" strokeLinejoin="round" {...props} />
</svg>)

export const ChevronDownIcon = ({ className }) => (<svg width="10" className={className} height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
</svg>)


export const ChevronDownLargeIcon = ({ className }) => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="21"
  fill="none"
  viewBox="0 0 20 21"
>
  <path
    stroke="#5473E3"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M5 8l5 5 5-5"
  ></path>
</svg>)

export const ImageIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="60"
  height="60"
  fill="none"
  viewBox="0 0 60 60"
>
  <path
    stroke="#F7F7F7"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="3.75"
    d="M2.5 52.5v-5a10 10 0 0110-10h8.75M21.25 27.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z"
  ></path>
  <path
    stroke="#F7F7F7"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2.5"
    d="M52.222 30H32.778A2.778 2.778 0 0030 32.778v19.444A2.778 2.778 0 0032.778 55h19.444A2.778 2.778 0 0055 52.222V32.778A2.778 2.778 0 0052.222 30z"
  ></path>
  <path
    stroke="#F7F7F7"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2.5"
    d="M38.75 41.25a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM55 46.818L47.969 40 32.5 55"
  ></path>
</svg>)

export const UnassignedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <circle cx="16" cy="16" r="16" fill="#CF3E3E"></circle>
    <g clipPath="url(#clip0_1_18)">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.173"
        d="M20.978 22.4v-1.422a2.844 2.844 0 00-2.844-2.845h-4.978a2.844 2.844 0 00-2.845 2.845V22.4m12.09-9.244l3.555 3.555m0-3.555l-3.555 3.555m-3.912-4.266a2.844 2.844 0 11-5.688 0 2.844 2.844 0 015.688 0z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1_18">
        <path
          fill="#fff"
          d="M0 0H17.067V17.067H0z"
          transform="translate(9.6 7.467)"
        ></path>
      </clipPath>
    </defs>
  </svg>
)
export const AssignedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="16" fill="#408F43"></circle>
    <g clipPath="url(#clip0_1_19)">
      <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.173" d="M20.978 22.4v-1.422a2.844 2.844 0 00-2.844-2.845h-4.978a2.844 2.844 0 00-2.845 2.845V22.4M21.69 15.29l1.422 1.422 2.844-2.844m-7.466-1.422a2.844 2.844 0 11-5.69 0 2.844 2.844 0 015.69 0z"></path>
    </g>
    <defs>
      <clipPath id="clip0_1_19">
        <path fill="#fff" d="M0 0H17.067V17.067H0z" transform="translate(9.6 7.467)"></path>
      </clipPath>
    </defs>
  </svg>
)
export const TotalClientsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
    <circle cx="16" cy="16" r="16" fill="#3753B8"></circle>
    <path fill="#3753B8" d="M9.6 22.4c0-.566.229-1.109.635-1.509.406-.4.957-.625 1.532-.625h11.7"></path>
    <path fill="#3753B8" d="M11.767 7.466h11.7v17.067h-11.7a2.184 2.184 0 01-1.532-.625A2.117 2.117 0 019.6 22.4V9.6c0-.566.229-1.109.635-1.509.406-.4.957-.625 1.532-.625z"></path>
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.564" d="M9.6 22.4c0-.566.229-1.109.635-1.509.406-.4.957-.625 1.532-.625h11.7M9.6 22.4c0 .566.229 1.108.635 1.508.406.4.957.625 1.532.625h11.7V7.466h-11.7c-.575 0-1.126.225-1.532.625-.406.4-.635.943-.635 1.509v12.8z"></path>
  </svg>
)

export const NotFoundIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="81"
  height="83"
  fill="none"
  viewBox="0 0 81 83"
>
  <path
    fill="#F58773"
    fillRule="evenodd"
    d="M6.317 28.633c-.305-.368-.437-1.182-.571-1.651-.2-.7-.498-1.297-.62-2.023-.099-.596.003-1.22-.082-1.817-.53-3.711.559-7.44 2.436-10.569.801-1.336 1.595-2.713 2.848-3.715 1.53-1.224 2.867-2.473 4.707-3.262 1.809-.775 3.667-.68 5.532-.99 1.005-.168 2.477-.548 3.51-.29.763.191 1.526.489 2.311.62 1.2.2 2.89.217 3.922.99.477.358.935.722 1.404 1.074.496.372 1.123.419 1.61.784 1.638 1.229 3.13 2.74 4.211 4.542.543.905 1.107 2.198 1.362 3.22.255 1.018.857 1.96 1.032 3.014.412 2.467.445 4.58-.165 7.018-.152.611-.056 1.298-.206 1.9-.466 1.862-1.62 4.55-3.014 5.944-.986.986-2.05 1.796-3.179 2.642-.774.58-2.042.931-2.972 1.197-1.541.44-2.986 1.01-4.541 1.322-1.411.282-2.89.09-4.294.371-2.074.415-4.785-.485-6.523-1.527-.614-.369-.666-.34-1.326-.671-1.548-.774-4.1-2.524-5.032-4.077-.187-.31-.566-.534-.784-.826-.81-1.08-1.734-2.53-1.734-3.922"
    clipRule="evenodd"
  ></path>
  <path
    fill="#5BCFB9"
    fillRule="evenodd"
    d="M20.693 51.665c-.404-.319-.508 1.027-.584 1.331-.358 1.434-1.162 2.93-1.162 4.421 0 .205.255.588.3.862.18 1.08.461 2.119.675 3.185.774 3.872.873 7.864 2.098 11.54.27.813 1.655.804 2.323.636.708-.176 1.517-.19 2.248-.337 1.646-.329 3.272-1.034 4.945-1.273 1.084-.155 2.142-.483 3.222-.637 2.668-.382 5.404-.535 8.056-1.124 4.22-.938 8.518-1.827 12.776-2.436 1.627-.232 3.268-.466 4.87-.787 1.586-.317 2.776-.306 3.56-1.873.186-.372.159-1.228.075-1.648-.253-1.264-.343-2.665-.525-3.934-.326-2.284-.224-4.739-.861-6.97-.407-1.42-1.126-2.893-1.424-4.383-.265-1.326-.5-2.673-.824-3.971-.05-.194.027-1.27-.413-1.124-.355.118-.787.787-1.049 1.049-1.002 1.002-1.988 2.026-2.997 3.035-3.03 3.03-6.374 5.886-9.404 8.917-.773.772-1.799 1.623-2.435 2.473-.552.735-1.38 1.52-2.211 1.798-.293.098-.87-.028-1.124-.112-.643-.215-1.359-.229-2.023-.45-.9-.3-1.656-1.145-2.623-1.386-.466-.117-.916-.573-1.424-.675-1.607-.321-2.994-1.31-4.496-1.91-1.64-.657-3.244-1.394-4.908-1.949-1.156-.385-2.154-1.24-3.334-1.536-.503-.126-.955-.674-1.462-.674"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M14.97 41.888c-.389 1.172-.784 2.46-.989 3.69-.12.723-.445 1.55-.445 2.241a.408.408 0 00.816 0c0-.65.32-1.426.434-2.108.198-1.188.583-2.433.958-3.566a.408.408 0 00-.775-.257zM19.932 43.278c-.015.066-.076.325-.09.394-.076.383-.226.737-.334 1.116-.271.95-.477 1.906-.712 2.849-.131.522-.355 1.021-.355 1.54a.408.408 0 00.816 0c0-.454.216-.886.33-1.343.234-.934.437-1.88.706-2.822.114-.4.269-.776.35-1.18.02-.102.101-.377.108-.534a.57.57 0 00-.057-.289.408.408 0 00-.762.269z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M12.04 49.259c.098-.03.284-.086.357-.115.464-.185.966-.268 1.44-.387.434-.108.933-.087 1.382-.023.436.063.838.257 1.281.312.692.087 1.497.272 2.063.65.334.222.626.59.902.866.141.142.346.253.466.373.012.012.007.03.01.047a.692.692 0 01-.007.15c-.027.2-.092.404-.117.551a3.17 3.17 0 00-.02.19.408.408 0 00.74.34c.056-.111.065-.275.085-.396.032-.194.124-.48.135-.738.01-.28-.063-.535-.249-.721-.12-.12-.325-.231-.466-.373-.31-.31-.65-.717-1.026-.968-.665-.443-1.603-.68-2.414-.78-.439-.056-.836-.249-1.268-.31-.55-.08-1.162-.095-1.695.038-.51.128-1.047.222-1.545.422-.091.036-.263.072-.384.118a.761.761 0 00-.266.159.874.874 0 00-.19.353c-.077.253-.104.614-.076.77a.408.408 0 00.803-.145c-.012-.07.034-.28.058-.383z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M11.176 49.944c-.13.393-.216.771-.315 1.169-.453 1.812-1.124 3.706-1.39 5.568-.28 1.96-1.1 3.873-1.382 5.842-.49 3.426-1.553 6.727-2.226 10.09-.179.894-.545 1.75-.722 2.638-.112.558-.09 1.203-.27 1.741-.268.804-.407 1.9-.197 2.74.094.376.328.637.59.872.165.147.349.274.446.468.088.176.282.386.522.574.317.249.71.466.938.542.565.188 1.147.434 1.728.628.423.14 1.292.021 1.63-.148.39-.195.839-.268 1.271-.38.53-.138 1.037-.328 1.442-.733.552-.551.792-1.298 1.072-2.138.495-1.484.84-3.04 1.234-4.615.149-.596.101-1.254.251-1.853.549-2.195.88-4.488 1.593-6.628.221-.664.184-1.431.408-2.104.994-2.982 1.305-6.188 2.082-9.295.153-.612.14-1.42.408-1.958.172-.342.42-1.007.42-1.407a.408.408 0 00-.816 0c0 .298-.206.787-.334 1.042-.292.586-.303 1.46-.47 2.125-.772 3.087-1.076 6.272-2.064 9.235-.224.673-.187 1.44-.408 2.104-.72 2.16-1.057 4.473-1.61 6.688-.15.6-.103 1.257-.252 1.853-.389 1.554-.728 3.09-1.216 4.555-.236.71-.41 1.354-.875 1.82-.298.297-.68.418-1.07.519-.488.127-.99.22-1.43.44-.21.105-.747.19-1.008.104-.581-.194-1.163-.44-1.727-.628-.17-.057-.458-.226-.694-.41-.13-.102-.248-.202-.295-.297-.12-.238-.308-.426-.51-.605-.185-.163-.399-.305-.464-.567-.176-.701-.044-1.615.18-2.285.189-.568.177-1.249.295-1.839.177-.887.543-1.743.722-2.638.676-3.378 1.742-6.694 2.234-10.135.281-1.969 1.102-3.883 1.382-5.841.262-1.836.927-3.701 1.373-5.486.097-.385.179-.751.306-1.132.025-.075.031-.242.033-.323a.408.408 0 00-.578-.559.562.562 0 00-.222.353 1.888 1.888 0 00-.015.294z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M17.531 49.506c.019.024.124.166.177.27.118.237.223.513.328.718.098.193.21.337.313.411a.543.543 0 00.324.109.408.408 0 00.155-.786 9.172 9.172 0 01-.236-.482c-.128-.292-.273-.59-.435-.769a.813.813 0 00-.385-.25.408.408 0 00-.24.779z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M18.363 50.706c-.513 1.909-.805 3.92-1.204 5.917-.23 1.145-.598 2.262-.788 3.405-.273 1.64-.775 3.243-1.097 4.855-.097.484-.385 1.072-.385 1.556a.408.408 0 00.817 0c0-.191.065-.4.133-.612.088-.27.187-.54.235-.784.324-1.62.827-3.233 1.102-4.88.189-1.135.556-2.244.783-3.38.396-1.98.683-3.973 1.192-5.865a.408.408 0 00-.788-.212z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M14.928 66.625c-.045.206-.209.75-.209 1.037a.408.408 0 00.816 0c0-.24.153-.693.19-.866a.408.408 0 00-.797-.171z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M9.32 81.296a.408.408 0 00-.4.68.542.542 0 00.444.145c.253-.023.719-.256.844-.319.95-.475 1.8-1.252 2.318-2.286.908-1.817.906-3.87 1.56-5.833.595-1.783.874-3.79 1.252-5.711a.408.408 0 10-.801-.157c-.37 1.888-.64 3.859-1.225 5.61-.641 1.926-.625 3.944-1.516 5.725a4.343 4.343 0 01-1.953 1.922c-.07.035-.419.18-.523.224zM6.993 6.773c-.5.265-.799.741-1.218 1.16C4.74 8.97 3.728 10.187 3.076 11.49c-.533 1.067-1.073 2.194-1.448 3.32-.233.697-.25 1.366-.576 2.017-.142.283-.17.618-.184.954-.009.216-.004.434-.092.61-.056.113-.09.276-.095.465-.005.277.052.632.052.822 0 1.083-.06 2.204.196 3.228.378 1.513.397 3.06.782 4.6.325 1.302 1.037 2.519 1.481 3.85.333.997 1.238 2.356 1.985 3.103.274.275.77.666.936.999.184.368.503.66.826.935.236.202.48.387.6.629.222.443.838.923 1.27 1.248 1.14.855 2.248 1.798 3.421 2.385.503.251 1.006.69 1.526 1.01.415.256.842.44 1.277.462a.408.408 0 00.043-.815c-.394-.02-.768-.25-1.14-.503-.453-.308-.899-.663-1.34-.884-1.133-.566-2.197-1.482-3.297-2.308-.342-.257-.855-.61-1.03-.96-.166-.332-.476-.608-.8-.885-.24-.203-.49-.407-.626-.68-.198-.395-.763-.883-1.089-1.21-.67-.67-1.49-1.889-1.788-2.785-.437-1.31-1.143-2.506-1.463-3.788-.385-1.54-.404-3.088-.782-4.601-.24-.96-.172-2.014-.172-3.03 0-.165-.042-.451-.05-.706-.004-.086-.018-.167.007-.216.114-.228.154-.494.17-.77.015-.273-.01-.561.106-.794.343-.686.375-1.389.62-2.124.363-1.09.888-2.18 1.404-3.213.613-1.227 1.571-2.37 2.546-3.345.365-.365.6-.805 1.044-1.027a.869.869 0 00.263-.232c.115-.144.244-.362.308-.459.337-.505 1.053-1.18 1.546-1.426 2.024-1.012 3.865-2.465 6.065-3.198.597-.199 1.242-.114 1.857-.267.351-.088.626-.326.957-.491.558-.28 1.41-.282 2.017-.484.066-.022.142-.01.22.001.143.02.29.058.433.083.29.052.564.048.781-.06.238-.12.666-.181.96-.108 1.921.48 3.981.301 5.814.912 4.923 1.641 8.986 5.307 11.844 9.593.797 1.197 1.004 2.613 1.63 3.867.067.133.037.325.024.518-.02.327-.035.658.046.9.188.563.639 1.134.828 1.703.077.228-.022.474-.066.716-.05.276-.065.547.02.802.349 1.044.391 1.855.13 2.9-.112.45-.075.937-.025 1.426.042.4.095.8.02 1.17-.332 1.664-1.102 3.212-1.514 4.858-.159.637-.677 1.31-1.012 1.868-.643 1.071-1.285 2.28-2.193 3.188-.56.56-1.247.97-1.794 1.518-2.632 2.632-6.038 4.083-9.503 5.238-1.447.483-3.068.302-4.508.782-.306.102-.644.05-.974-.013-.427-.082-.845-.192-1.198-.192a.408.408 0 000 .817c.308 0 .671.105 1.044.177.47.09.951.13 1.386-.014 1.44-.48 3.061-.3 4.509-.782 3.584-1.195 7.098-2.713 9.82-5.436.548-.548 1.236-.959 1.795-1.518.954-.955 1.64-2.219 2.316-3.346.372-.62.927-1.38 1.104-2.089.415-1.659 1.188-3.22 1.523-4.896.09-.448.041-.932-.009-1.414-.04-.392-.086-.783.005-1.143.302-1.21.255-2.149-.147-3.357-.075-.224.025-.467.068-.71.05-.276.064-.55-.022-.808-.19-.569-.641-1.14-.828-1.703-.068-.202-.008-.493.003-.762.012-.289-.016-.56-.118-.763-.641-1.284-.864-2.73-1.681-3.955C38.183 6.46 33.97 2.678 28.875.98 27.023.362 24.942.536 23.002.05c-.467-.116-1.146-.02-1.524.17-.044.022-.099.01-.156.004-.13-.014-.27-.049-.408-.075-.273-.054-.54-.072-.763.002-.64.214-1.535.234-2.124.529-.277.138-.497.356-.79.429-.636.159-1.3.08-1.917.285-2.237.746-4.114 2.213-6.172 3.242-.591.296-1.456 1.098-1.86 1.703-.058.089-.26.382-.295.434z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M5.355 26.623c.007 1.109.496 1.753.963 2.687.222.444.434 1.108.766 1.44.117.117.359.37.553.615.101.126.194.244.223.33.39 1.168 2.087 3.11 3.241 3.687.164.082.276.242.407.37.153.15.32.275.52.342.105.035.253.149.414.277.296.235.61.53.762.682.101.102.248.18.414.235.132.044.282.068.382.118.993.497 2.036.88 3.036 1.38 2.442 1.221 6.487 1.185 9.145.298.675-.224 1.401-.317 2.12-.436.782-.13 1.555-.292 2.259-.644 3.12-1.56 7.324-4.064 8.578-7.827.644-1.933 1.052-3.94 1.702-5.89.105-.314.125-.702.102-1.107-.03-.514-.127-1.057-.127-1.46 0-2.917-.508-6.027-2.244-8.342-1.25-1.666-1.938-3.646-3.396-5.105-1.392-1.391-3.394-2.388-5.22-2.997-.764-.254-1.502-.669-2.255-.92-3.754-1.251-8.294-1-11.967.468-3.149 1.26-5.941 3.79-7.78 6.548-.581.872-1.276 1.852-1.611 2.858-.604 1.81-1.155 3.6-1.62 5.459-.25 1.002-.154 2.694.042 3.675.037.182.001.381-.006.575-.008.2.005.396.065.579.078.232.198.673.263 1.075.036.225.062.436.033.572a.408.408 0 00.236.458zm.578-.396c.14.064.238.206.238.37 0 .98.467 1.528.877 2.348.104.21.203.472.314.722.087.195.177.384.3.506.232.233.862.933.972 1.264.34 1.019 1.824 2.71 2.832 3.215.175.087.323.22.46.362.114.116.21.255.36.306.373.124 1.2.862 1.495 1.156.05.05.145.054.23.078.13.036.257.074.354.122.993.497 2.036.88 3.036 1.38 2.276 1.138 6.045 1.08 8.522.254.715-.238 1.483-.34 2.245-.468.7-.116 1.395-.252 2.027-.568 2.953-1.477 6.981-3.793 8.169-7.355.644-1.933 1.052-3.94 1.702-5.89.098-.292.077-.672.042-1.052-.04-.452-.109-.906-.109-1.257 0-2.743-.448-5.675-2.08-7.852-1.227-1.635-1.89-3.586-3.322-5.018-1.304-1.304-3.188-2.229-4.901-2.8-.763-.254-1.5-.669-2.254-.92-3.579-1.193-7.905-.948-11.406.452-2.999 1.2-5.653 3.616-7.403 6.243-.544.815-1.204 1.724-1.517 2.663-.597 1.79-1.142 3.56-1.602 5.399-.226.904-.127 2.431.05 3.317.036.175.033.361.022.548-.01.174-.04.35.012.508.142.426.384 1.443.335 1.966z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M30.332 9.78c.031.016.165.09.248.147.195.135.397.287.542.36.772.385 1.75 1.795 2.164 2.624.093.185.218.336.35.48.12.132.257.25.318.432.41 1.228 1.072 2.614 1.678 3.827.151.302.215.659.284 1.016.082.425.17.851.352 1.221a12.76 12.76 0 01-.019.276c-.017.194 0 .378.073.523.139.276.186.729.194 1.217.012.79-.102 1.673-.262 2.152-.492 1.477-.819 2.78-1.542 4.226a.408.408 0 00.73.365c.742-1.483 1.081-2.818 1.587-4.332.18-.54.316-1.534.303-2.424-.01-.622-.098-1.194-.272-1.552.002-.027.012-.188.02-.276.016-.194 0-.378-.074-.523-.155-.31-.22-.67-.29-1.028-.083-.432-.17-.86-.354-1.226-.59-1.18-1.236-2.526-1.634-3.72a1.594 1.594 0 00-.325-.542c-.131-.153-.29-.284-.387-.477-.477-.954-1.64-2.545-2.529-2.99-.181-.09-.455-.325-.68-.452-.184-.104-.357-.147-.483-.14a.408.408 0 00.008.816zM31.772 32.34c.493-.356 1.189-.846 1.71-1.368a.408.408 0 00-.577-.577c-.49.49-1.146.948-1.61 1.282a.408.408 0 00.477.662zM22.026 50.506a3.253 3.253 0 01-.018-.37c.011-.33.057-.69.057-.838 0-1.363-.074-2.74-.074-4.112 0-.097-.03-.544-.03-.949 0-.17.02-.39.028-.464a.408.408 0 00-.516-.6c-.1.05-.25.204-.295.489-.067.422-.004 1.373-.004 1.524 0 1.373.075 2.749.075 4.112 0 .192-.077.741-.056 1.12.016.29.108.509.212.614a.408.408 0 00.62-.526zM18.959 57.331c.274 1.175.03 2.453.325 3.63.662 2.649.549 5.546 1.396 8.088.276.828.319 1.628.453 2.379.152.847.412 1.635 1.123 2.346.302.302.78.41 1.31.38.615-.035 1.304-.247 1.686-.31 2.425-.405 4.745-1.07 7.185-1.34 4.468-.497 8.882-1.765 13.39-2.329 2.481-.31 5.028-.772 7.46-1.258 3.467-.693 7.604-.429 10.755-2.004a.408.408 0 00-.365-.73c-3.09 1.544-7.151 1.254-10.55 1.934-2.413.483-4.94.94-7.402 1.249-4.503.563-8.914 1.83-13.378 2.326-2.455.273-4.79.94-7.229 1.346-.362.06-1.015.268-1.6.301-.27.016-.53.014-.685-.142-.578-.577-.773-1.225-.897-1.913-.14-.787-.192-1.625-.482-2.493-.84-2.523-.721-5.399-1.378-8.027-.294-1.174-.049-2.447-.322-3.618a.408.408 0 00-.795.185z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M60.444 42.63c-.139.915-.027 2.07.348 2.82.16.321.155.74.154 1.162-.002.537-.008 1.08.138 1.515.392 1.179.509 2.558.895 3.716.949 2.847.756 6.073 1.468 8.922.12.477.063.968.18 1.432.164.658.463 1.89.43 2.893-.01.295-.049.569-.138.793-.066.163-.157.298-.303.371a.408.408 0 00.365.73c.459-.23.731-.7.837-1.314.198-1.147-.191-2.835-.4-3.67-.116-.465-.06-.956-.18-1.433-.716-2.869-.53-6.116-1.485-8.982-.386-1.158-.503-2.537-.895-3.715-.12-.361-.097-.812-.096-1.255.001-.558-.028-1.106-.24-1.53-.31-.62-.386-1.576-.27-2.332a.409.409 0 00-.808-.123zM20.91 50.977a.408.408 0 00-.757.3c.075.224.26.395.532.494.188.069.424.105.645.135.139.02.27.026.344.063.774.388 1.516 1.062 2.425 1.365.525.175 1.157.314 1.648.56 2.437 1.219 4.986 2.314 7.34 3.491.612.306 1.36.786 2.098.971.554.139 1.221.726 1.725 1.029 1.653.992 3.457 1.759 5.357 1.759a.408.408 0 000-.816c-1.754 0-3.412-.728-4.937-1.643-.564-.338-1.327-.966-1.947-1.12-.682-.171-1.366-.627-1.93-.91-2.355-1.177-4.904-2.272-7.341-3.491-.524-.262-1.195-.418-1.755-.604-.871-.29-1.576-.95-2.319-1.32-.17-.086-.512-.122-.833-.177a2.183 2.183 0 01-.294-.086z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M60.572 43.247a.408.408 0 00-.136-.793c-.095 0-.264.05-.438.207-.264.241-.712.865-.952 1.026-1.45.966-2.407 2.487-3.823 3.549-1.103.827-1.897 2.217-2.999 3.044-3.837 2.877-6.513 7.2-10.286 10.143a.408.408 0 00.502.644c3.768-2.94 6.44-7.26 10.274-10.135 1.102-.826 1.896-2.216 2.999-3.043 1.403-1.053 2.349-2.566 3.786-3.523.16-.107.407-.38.643-.654.152-.177.375-.408.43-.465zM40.521 9.892a.408.408 0 00-.405.708c.1.061.242.103.403.114.247.017.556-.035.706-.073.727-.181 1.553-.156 2.3-.24 2.05-.227 4.163.113 6.21-.143.693-.086 1.448.061 2.132-.076.773-.154 1.616-.023 2.39-.178.124-.025.315-.056.49-.055.066 0 .13-.002.174.02a.408.408 0 00.365-.73 1.252 1.252 0 00-.535-.106 3.46 3.46 0 00-.655.07c-.773.155-1.616.024-2.389.179-.665.133-1.4-.018-2.074.066-2.042.256-4.152-.085-6.199.142-.782.087-1.645.07-2.407.26-.104.026-.47.04-.506.042z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M55.466 9.967a.408.408 0 00-.47-.634c-.122.049-.288.202-.336.5-.073.447.037 1.471.09 1.735.404 2.023.284 4.553.284 6.64 0 3.698.058 7.416.058 11.163 0 1.851-.294 4.06.066 5.865.13.645.003 1.57-.008 2.416-.009.656.052 1.269.277 1.72.132.262.117.581.11.902-.012.44-.025.883.102 1.265.331.993.388 2.602.388 3.67a.408.408 0 00.816 0c0-1.144-.075-2.865-.43-3.928-.099-.297-.07-.644-.06-.986.01-.46-.007-.912-.196-1.289-.224-.45-.207-1.107-.178-1.774.033-.78.096-1.573-.02-2.156-.352-1.756-.05-3.905-.05-5.705 0-3.747-.06-7.465-.06-11.163 0-2.137.115-4.728-.3-6.8a7.783 7.783 0 01-.1-1.186c0-.091.011-.203.017-.255z"
    clipRule="evenodd"
  ></path>
  <path
    fill="#000"
    fillRule="evenodd"
    d="M55.904 39.133c.338.44.837.781 1.227 1.172.983.982 2.169 1.86 3.055 2.746a.408.408 0 00.577-.577c-.886-.886-2.072-1.764-3.055-2.746-.37-.37-.852-.686-1.167-1.106a6.266 6.266 0 00-.222-.228.406.406 0 00-.51-.323.418.418 0 00-.295.26.444.444 0 00-.006.316c.021.063.07.15.146.237.074.085.218.22.25.25zm.295-.374zM34.122 57.527c3.707-.467 7.644-.896 11.381-.896a.408.408 0 000-.816c-3.77 0-7.743.431-11.483.903a.408.408 0 00.102.81zM32.102 41.48c.712-.105 1.643.14 2.391.14 1.866 0 3.9-.102 5.752-.334 1.84-.23 3.733-.069 5.566-.33 2.115-.303 4.4-.562 6.538-.562a.408.408 0 000-.816c-2.176 0-4.5.262-6.654.57-1.828.26-3.716.099-5.552.328-1.818.228-3.816.327-5.65.327-.785 0-1.763-.24-2.511-.13a.408.408 0 00.12.808zM38.542 35.911a.407.407 0 00-.324-.046.405.405 0 00-.305.283.39.39 0 00.081.395c.03.036.157.138.385.175.33.054 1.104.107 1.3.107.984 0 1.994-.036 2.965-.144 1.901-.211 3.86 0 5.754-.236 1.01-.126 2.215-.28 3.2-.28a.408.408 0 000-.816c-1.017 0-2.259.156-3.302.286-1.89.236-3.845.024-5.742.235-.941.105-1.921.139-2.876.139-.157 0-.883-.072-1.136-.098zm-.072.73l-.01.003h.003l.007-.003zm.022-.01l-.01.005.005-.002.005-.002zm.018-.008l-.004.002.004-.002zM41.809 31.142a.405.405 0 00-.13-.013c-.273.017-.345.204-.357.228a.38.38 0 00.043.431.386.386 0 00.208.143c.051.015.944.064 1.156.064.798 0 1.567-.104 2.353-.191a64.485 64.485 0 016.975-.374.408.408 0 000-.816c-2.302 0-4.76.123-7.065.379-.756.084-1.496.186-2.263.186-.152 0-.708-.022-.92-.037zm.013.785zM42.656 28.344c.22.132.557.2.948.206.729.01 1.675-.178 2.118-.222 2.054-.206 4.27-.281 6.32-.281a.408.408 0 000-.816c-2.076 0-4.32.077-6.401.285-.368.036-1.093.178-1.736.212-.338.017-.65.023-.83-.084a.408.408 0 00-.419.7zM51.165 24.02a.408.408 0 00.551-.6c-.138-.138-.415-.238-.769-.247-.524-.015-1.27.127-1.545.127-1.85 0-3.97.504-5.788.184a.408.408 0 00-.142.803c1.863.329 4.036-.17 5.93-.17.237 0 .823-.105 1.317-.126a3 3 0 01.446.03zM59.17 8.077c-.01-.064.023-.15.06-.257.058-.17.148-.368.257-.58.546-1.066 1.544-2.466 1.71-2.72a.408.408 0 00-.685-.445c-.17.262-1.191 1.7-1.752 2.793-.288.563-.437 1.062-.397 1.33a.408.408 0 00.807-.121zM77.27 42.667a.829.829 0 01.142-.048c.119-.024.26-.03.414-.028.746.01 1.761.215 2.447.215a.408.408 0 000-.816c-.837 0-2.157-.294-2.908-.19-.4.055-.676.223-.811.464-.13.23-.162.575.08 1.061a.408.408 0 10.73-.363 1.053 1.053 0 01-.086-.225.435.435 0 01-.008-.07z"
    clipRule="evenodd"
  ></path>
</svg>
)

export const EmojiSadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="59"
    height="59"
    fill="none"
    viewBox="0 0 59 59"
  >
    <path
      fill="#E07A1B"
      d="M29.75 5.065a24.167 24.167 0 100 48.334 24.167 24.167 0 000-48.334zM17.667 23.19c0-1.933 1.691-3.625 3.625-3.625 1.933 0 3.625 1.692 3.625 3.625 0 1.934-1.692 3.625-3.625 3.625-1.934 0-3.625-1.691-3.625-3.625zm18.777 18.681c-1.087-1.764-3.673-2.972-6.694-2.972-3.02 0-5.607 1.208-6.694 2.972l-3.432-3.431c2.175-2.635 5.897-4.375 10.126-4.375 4.23 0 7.951 1.74 10.126 4.375l-3.432 3.431zm1.764-15.056c-1.933 0-3.624-1.691-3.624-3.625 0-1.933 1.691-3.625 3.624-3.625 1.934 0 3.626 1.692 3.626 3.625 0 1.934-1.692 3.625-3.626 3.625z"
    ></path>
  </svg>
)

export const QrCode = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="145"
    height="145"
    fill="none"
    viewBox="0 0 145 145"
  >
    <rect
      width="144"
      height="144"
      x="0.75"
      y="0.232"
      fill="#F7F7F7"
      rx="12.112"
    ></rect>
    <path
      fill="#171E25"
      d="M8.75 8.232V52.54h44.308V8.232H8.75zm54.154 0v9.847h9.846V8.232h-9.846zm9.846 9.847v9.846h-9.846v19.692h9.846v-9.846h9.846V18.079H72.75zm0 29.538v14.77H28.442v9.845h-9.846v9.847h19.692v-9.847h9.847v9.847H72.75v-9.847h9.846v9.847h14.77v-9.847h9.846v-9.846H82.596V47.617H72.75zm34.462 24.615v9.847h29.538v-9.847h-9.846v-9.846h-9.846v9.846h-9.846zm-88.616 0v-9.846H8.75v9.846h9.846zm73.846-64V52.54h44.308V8.232H92.442zM18.596 18.08h24.616v24.615H18.596V18.079zm83.692 0h24.616v24.615h-24.616V18.079zm-78.769 4.923V37.77h14.77V23h-14.77zm83.693 0V37.77h14.769V23h-14.769zm-44.308 64v9.846h9.846v-9.846h-9.846zm9.846 9.846v9.846h-9.846v19.692h9.846v-9.846h19.692v-9.846h9.846v-9.846h9.847v9.846h-9.847v9.846h-9.846v19.692h9.846v-9.846h9.847v-9.846h4.923v9.846h-4.923v9.846h9.846v-9.846h4.923v-9.846h9.846V96.848h-9.846v-9.846H92.442v9.846H72.75zm54.154 29.538v9.846h9.846v-9.846h-9.846zm-54.154 0v9.846h9.846v-9.846H72.75zm-64-34.461v44.307h44.308V91.925H8.75zm9.846 9.846h24.616v24.615H18.596v-24.615zm4.923 4.923v14.769h14.77v-14.769h-14.77z"
    ></path>
  </svg>
)

export const LogoutIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.4995 2.5H15.8328C16.2749 2.5 16.6988 2.67559 17.0114 2.98816C17.3239 3.30072 17.4995 3.72464 17.4995 4.16667V15.8333C17.4995 16.2754 17.3239 16.6993 17.0114 17.0118C16.6988 17.3244 16.2749 17.5 15.8328 17.5H12.4995M8.33252 14.1666L12.4992 9.99992M12.4992 9.99992L8.33252 5.83325M12.4992 9.99992L2.49951 10" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
</svg>)

export const PlusRoundedPrimaryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
      d="M12 8v8m-4-4h8m6 0c0 5.523-4.477 10-10 10-5.522 0-10-4.477-10-10S6.478 2 12 2c5.523 0 10 4.477 10 10z"
    ></path>
  </svg>
)

export const MailCyanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="#37C2CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.667 4c0-.733-.6-1.333-1.333-1.333H2.667c-.733 0-1.333.6-1.333 1.333m13.333 0v8c0 .733-.6 1.333-1.333 1.333H2.667c-.733 0-1.333-.6-1.333-1.333V4m13.333 0L8 8.667 1.334 4"
    ></path>
  </svg>
)

export const MapCyanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="#37C2CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 15.333s6-4 6-8.666a6 6 0 10-12 0c0 4.666 6 8.666 6 8.666z"
    ></path>
    <path
      stroke="#37C2CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 8.667a2 2 0 100-4 2 2 0 000 4z"
    ></path>
  </svg>
)

export const PhoneCyanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clipPath="url(#clip0_1_10)">
      <path
        stroke="#37C2CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.667 13.28v-2a1.333 1.333 0 00-1.147-1.353 8.56 8.56 0 01-1.873-.467 1.333 1.333 0 00-1.407.3l-.847.847a10.667 10.667 0 01-4-4l.847-.847a1.333 1.333 0 00.3-1.407 8.56 8.56 0 01-.467-1.873A1.333 1.333 0 004.74 1.333h-2a1.333 1.333 0 00-1.327 1.454c.22 2.06.92 4.04 2.047 5.78a13.001 13.001 0 004 4 13.194 13.194 0 005.753 2.046 1.333 1.333 0 001.454-1.333z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1_10">
        <path fill="#fff" d="M0 0H16V16H0z"></path>
      </clipPath>
    </defs>
  </svg>
)

export const MobileCyanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke="#37C2CC"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.334 1.333H4.667c-.736 0-1.333.597-1.333 1.334v10.666c0 .737.597 1.334 1.333 1.334h6.667c.736 0 1.333-.597 1.333-1.334V2.667c0-.737-.597-1.334-1.333-1.334zM8 12h.007"
    ></path>
  </svg>
)

export const CalendarCyanIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" >
    <path stroke="#37C2CC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.8" d="M12.667 2.667H3.333C2.597 2.667 2 3.263 2 4v9.333c0 .737.597 1.333 1.333 1.333h9.334c.736 0 1.333-.596 1.333-1.333V4c0-.737-.597-1.333-1.333-1.333zM10.666 1.333V4M5.334 1.333V4M2 6.667h12"></path>
  </svg>
)

export const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.09 8.26L12 2 8.91 8.26 2 9.27l5 4.87-1.18 6.88L12 17.77l6.18 3.25L17 14.14l5-4.87-6.91-1.01z"
    ></path>
  </svg>
)

export const ActiveStarIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="yellow"
  viewBox="0 0 20 20"
>
  <path
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12.575 6.883L10 1.667 7.425 6.883l-5.758.842 4.167 4.058-.984 5.734L10 14.808l5.15 2.709-.983-5.734 4.167-4.058-5.759-.842z"
  ></path>
</svg>)

export const LoginWhiteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.5 2.5h3.333A1.666 1.666 0 0117.5 4.167v11.666a1.666 1.666 0 01-1.667 1.667H12.5m-4.167-3.333L12.5 10m0 0L8.333 5.833M12.5 10h-10"
    ></path>
  </svg>
)


export const SpinnerSecondary = ({ className = "w-5 h-5 min-w-5" }) => (<svg aria-hidden="true" role="status" className={`${className} inline  mr-3 text-gray-200 animate-spin dark:text-gray-600`} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2" />
</svg>)

SpinnerSecondary.propTypes = {
  className: propTypes.string
}

SpinnerSecondary.defaultProps = {
  className: "w-4 h-4"
}

export const SpinnerPrimary = ({ className = "w-5 h-5 min-w-5" }) => (<svg aria-hidden="true" role="status" className={`inline  mr-3 text-white animate-spin ${className}`} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
</svg>)

export const UnAssignIcon = () => (<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.334 15.5V13.8333C13.334 12.9493 12.9828 12.1014 12.3577 11.4763C11.7326 10.8512 10.8847 10.5 10.0007 10.5H4.16732C3.28326 10.5 2.43542 10.8512 1.8103 11.4763C1.18517 12.1014 0.833984 12.9493 0.833984 13.8333V15.5M19.168 7.16675H14.168M10.4176 3.83333C10.4176 5.67428 8.92526 7.16667 7.08431 7.16667C5.24336 7.16667 3.75098 5.67428 3.75098 3.83333C3.75098 1.99238 5.24336 0.5 7.08431 0.5C8.92526 0.5 10.4176 1.99238 10.4176 3.83333Z" stroke="#5473E3" strokeLinecap="round" strokeLinejoin="round" />
</svg>
)

export const UserMinus = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.333 17.5V15.8333C13.333 14.9493 12.9818 14.1014 12.3567 13.4763C11.7316 12.8512 10.8837 12.5 9.99967 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5M19.167 9.16675H14.167M10.4167 5.83333C10.4167 7.67428 8.92428 9.16667 7.08333 9.16667C5.24238 9.16667 3.75 7.67428 3.75 5.83333C3.75 3.99238 5.24238 2.5 7.08333 2.5C8.92428 2.5 10.4167 3.99238 10.4167 5.83333Z" stroke="#A3B3C8" strokeLinecap="round" strokeLinejoin="round" />
</svg>)


export const EyeIcon = () => (<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_2083_7100)">
    <path d="M10.7497 4.06641C4.91634 4.06641 1.58301 10.7331 1.58301 10.7331C1.58301 10.7331 4.91634 17.3997 10.7497 17.3997C16.583 17.3997 19.9163 10.7331 19.9163 10.7331C19.9163 10.7331 16.583 4.06641 10.7497 4.06641Z" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.75 13.2324C12.1307 13.2324 13.25 12.1131 13.25 10.7324C13.25 9.35171 12.1307 8.23242 10.75 8.23242C9.36929 8.23242 8.25 9.35171 8.25 10.7324C8.25 12.1131 9.36929 13.2324 10.75 13.2324Z" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_2083_7100">
      <rect width="20" height="20" fill="white" transform="translate(0.75 0.732422)" />
    </clipPath>
  </defs>
</svg>
)
export const SmallEyeIcon = () => (<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_2083_7100)">
    <path d="M10.7497 4.06641C4.91634 4.06641 1.58301 10.7331 1.58301 10.7331C1.58301 10.7331 4.91634 17.3997 10.7497 17.3997C16.583 17.3997 19.9163 10.7331 19.9163 10.7331C19.9163 10.7331 16.583 4.06641 10.7497 4.06641Z" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.75 13.2324C12.1307 13.2324 13.25 12.1131 13.25 10.7324C13.25 9.35171 12.1307 8.23242 10.75 8.23242C9.36929 8.23242 8.25 9.35171 8.25 10.7324C8.25 12.1131 9.36929 13.2324 10.75 13.2324Z" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_2083_7100">
      <rect width="20" height="20" fill="white" transform="translate(0.75 0.732422)" />
    </clipPath>
  </defs>
</svg>
)

export const EyeClose = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_2086_53340)">
    <path d="M14.9497 14.9499C13.5252 16.0358 11.7906 16.6373 9.99967 16.6666C4.16634 16.6666 0.833008 9.99994 0.833008 9.99994C1.86958 8.06819 3.30729 6.38045 5.04967 5.04994M8.24967 3.53327C8.82328 3.39901 9.41056 3.33189 9.99967 3.33327C15.833 3.33327 19.1663 9.99994 19.1663 9.99994C18.6605 10.9463 18.0572 11.8372 17.3663 12.6583M11.7663 11.7666C11.5375 12.0122 11.2615 12.2092 10.9548 12.3459C10.6481 12.4825 10.3171 12.556 9.98142 12.5619C9.64574 12.5678 9.31231 12.5061 9.00102 12.3803C8.68972 12.2546 8.40694 12.0675 8.16955 11.8301C7.93215 11.5927 7.745 11.3099 7.61926 10.9986C7.49353 10.6873 7.43178 10.3539 7.4377 10.0182C7.44362 9.68252 7.5171 9.35148 7.65374 9.04481C7.79038 8.73815 7.98738 8.46215 8.23301 8.23327" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M0.833008 0.833374L19.1663 19.1667" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
  </g>
  <defs>
    <clipPath id="clip0_2086_53340">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
)

export const ProfilePicIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="none"
    viewBox="0 0 30 30"
  >
    <circle cx="15" cy="15" r="15" fill="#A3B3C8"></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 20v-1.222c0-1.35-1.12-2.445-2.5-2.445h-5c-1.38 0-2.5 1.095-2.5 2.445V20"
    ></path>
    <ellipse
      cx="15"
      cy="11.444"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      rx="2.5"
      ry="2.444"
    ></ellipse>
  </svg>
)

export const DeleteIconWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M2.5 5h1.667m0 0H17.5M4.167 5v11.667a1.667 1.667 0 001.667 1.666h8.333a1.667 1.667 0 001.667-1.666V5h-2.5M4.167 5h2.5m0 0h6.667M6.667 5V3.333a1.667 1.667 0 011.667-1.666h3.333a1.667 1.667 0 011.667 1.666V5M8.333 9.167v5m3.334-5v5"></path>
  </svg>
)

export const EditIconWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M9.167 3.333H3.334A1.667 1.667 0 001.667 5v11.667a1.667 1.667 0 001.667 1.666H15a1.666 1.666 0 001.667-1.666v-5.834"></path>
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M16.667 1.566c-.469 0-.919.186-1.25.517L7.5 10l-.833 3.333L10 12.5l7.917-7.917a1.768 1.768 0 00-1.25-3.017z"></path>
  </svg>
)

export const UserCheckIconWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M13.333 17.5v-1.667A3.333 3.333 0 0010 12.5H4.166a3.333 3.333 0 00-3.333 3.333V17.5m13.334-8.333l1.667 1.666L19.167 7.5m-8.75-1.667a3.333 3.333 0 11-6.667 0 3.333 3.333 0 016.667 0z"></path>
  </svg>
)
export const CalendarIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zM16 2v4M8 2v4M3 10h18" {...props}></path>
  </svg>
)

export const RolesIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-refresh-cw"
    viewBox="0 0 24 24" {...props}
  >
    <path d="M23 4v6h-6M1 20v-6h6"></path>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
  </svg>
)

export const RolesWhiteIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.1663 17.5V15.8333C14.1663 14.9493 13.8152 14.1014 13.19 13.4763C12.5649 12.8512 11.7171 12.5 10.833 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5M19.167 17.5001V15.8334C19.1664 15.0948 18.9206 14.3774 18.4681 13.7937C18.0156 13.2099 17.3821 12.793 16.667 12.6084M13.333 2.6084C14.05 2.79198 14.6855 3.20898 15.1394 3.79366C15.5932 4.37833 15.8395 5.09742 15.8395 5.83756C15.8395 6.57771 15.5932 7.2968 15.1394 7.88147C14.6855 8.46615 14.05 8.88315 13.333 9.06673M10.8337 5.83333C10.8337 7.67428 9.34127 9.16667 7.50033 9.16667C5.65938 9.16667 4.16699 7.67428 4.16699 5.83333C4.16699 3.99238 5.65938 2.5 7.50033 2.5C9.34127 2.5 10.8337 3.99238 10.8337 5.83333Z" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

)


export const RoleActiveIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.1663 17.5V15.8333C14.1663 14.9493 13.8152 14.1014 13.19 13.4763C12.5649 12.8512 11.7171 12.5 10.833 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5M19.167 17.5001V15.8334C19.1664 15.0948 18.9206 14.3774 18.4681 13.7937C18.0156 13.2099 17.3821 12.793 16.667 12.6084M13.333 2.6084C14.05 2.79198 14.6855 3.20898 15.1394 3.79366C15.5932 4.37833 15.8395 5.09742 15.8395 5.83756C15.8395 6.57771 15.5932 7.2968 15.1394 7.88147C14.6855 8.46615 14.05 8.88315 13.333 9.06673M10.8337 5.83333C10.8337 7.67428 9.34127 9.16667 7.50033 9.16667C5.65938 9.16667 4.16699 7.67428 4.16699 5.83333C4.16699 3.99238 5.65938 2.5 7.50033 2.5C9.34127 2.5 10.8337 3.99238 10.8337 5.83333Z" stroke="#3753B8" strokeLinecap="round" strokeLinejoin="round" />
</svg>
)

export const TikMarkIcon = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#5473E3" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M16.5714 9L10.6786 15L8 12.2727" stroke="#5473E3" strokeLinecap="round" strokeLinejoin="round" />
</svg>
)

export const DownChevron = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 9L12 15L18 9" stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" />
</svg>
)

export const TikGreenIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    stroke="#394657"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M16.667 5L7.5 14.167 3.333 10"
  ></path>
</svg>
)


export const DeleteIcon = (props) => (
  <svg width={props.width || "20"} height={props.height || "20"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 4.99927H4.16667M4.16667 4.99927H17.5M4.16667 4.99927L4.16699 16.666C4.16699 17.108 4.34259 17.532 4.65515 17.8445C4.96771 18.1571 5.39163 18.3327 5.83366 18.3327H14.167C14.609 18.3327 15.0329 18.1571 15.3455 17.8445C15.6581 17.532 15.8337 17.108 15.8337 16.666V4.99935H13.3337M4.16667 4.99927L6.66699 4.99935M6.66699 4.99935H13.3337M6.66699 4.99935V3.33268C6.66699 2.89065 6.84259 2.46673 7.15515 2.15417C7.46771 1.84161 7.89163 1.66602 8.33366 1.66602H11.667C12.109 1.66602 12.5329 1.84161 12.8455 2.15417C13.1581 2.46673 13.3337 2.89065 13.3337 3.33268V4.99935M8.33301 9.16602V14.166M11.667 9.16602V14.166" stroke="#5473E3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>)

export const SyncIcon = (props) => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M19.166 3.33325V8.33325M19.166 8.33325H14.166M19.166 8.33325L15.2987 4.69998C14.4031 3.80391 13.2951 3.14932 12.078 2.79729C10.861 2.44527 9.57462 2.40727 8.33894 2.68686C7.10325 2.96645 5.95853 3.55451 5.01159 4.39616C4.06464 5.23782 3.34634 6.30564 2.9237 7.49998M0.832031 16.6667V11.6667M0.832031 11.6667H5.83203M0.832031 11.6667L4.6987 15.3C5.59432 16.1961 6.70234 16.8506 7.91937 17.2027C9.1364 17.5547 10.4228 17.5927 11.6585 17.3131C12.8941 17.0335 14.0389 16.4455 14.9858 15.6038C15.9328 14.7621 16.6511 13.6943 17.0737 12.5" stroke="#5473E3" strokeLinecap="round" strokeLinejoin="round" />
</svg>
)

export const CopyIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.16797 12.9993H3.33464C2.89261 12.9993 2.46868 12.8238 2.15612 12.5112C1.84356 12.1986 1.66797 11.7747 1.66797 11.3327V3.83268C1.66797 3.39065 1.84356 2.96673 2.15612 2.65417C2.46868 2.34161 2.89261 2.16602 3.33464 2.16602H10.8346C11.2767 2.16602 11.7006 2.34161 12.0131 2.65417C12.3257 2.96673 12.5013 3.39065 12.5013 3.83268V4.66602M9.16764 7.99939H16.6676C17.5881 7.99939 18.3343 8.74558 18.3343 9.66606V17.1661C18.3343 18.0865 17.5881 18.8327 16.6676 18.8327H9.16764C8.24717 18.8327 7.50098 18.0865 7.50098 17.1661V9.66606C7.50098 8.74558 8.24717 7.99939 9.16764 7.99939Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>)

export const DocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" >
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M12.875 3H6.75c-.464 0-.91.19-1.237.527A1.826 1.826 0 005 4.8v14.4c0 .477.184.935.513 1.273.328.337.773.527 1.237.527h10.5c.464 0 .91-.19 1.237-.527.329-.338.513-.796.513-1.273V9.3L12.875 3z" ></path> <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M13 3v6h6" ></path> <path fill="#677A8E" fillRule="evenodd" d="M13.35 14.578c-.39-.434-.774-.919-1.12-1.355l-.008-.01a48.103 48.103 0 00-.468-.585l-.011-.013c.215-.613.338-1.116.366-1.493.07-.96-.038-1.579-.328-1.89a.721.721 0 00-.767-.192c-.198.066-.467.244-.62.715-.23.7-.118 1.943.532 2.97a21.93 21.93 0 01-1.142 2.465c-.85.298-1.53.69-2.016 1.166-.636.621-.895 1.237-.71 1.69.114.281.378.449.705.449.228 0 .475-.082.713-.238.602-.394 1.389-1.705 1.81-2.466a11.226 11.226 0 012.173-.426c.198-.02.395-.034.584-.045.767.81 1.394 1.236 1.971 1.343.116.021.233.032.346.032.47 0 .86-.187 1.041-.502a.744.744 0 00-.008-.76c-.32-.555-1.287-.86-2.723-.86-.103 0-.21.001-.32.005zm-5.273 3.069a.643.643 0 01-.314.119.14.14 0 01-.032-.004c-.015-.072.037-.387.546-.884a3.85 3.85 0 01.9-.636c-.452.727-.858 1.247-1.1 1.405zm3.17-7.916c-.042.014-.107.087-.16.25-.147.45-.08 1.146.163 1.772a3.72 3.72 0 00.132-.683c.075-1.04-.093-1.295-.133-1.34h-.001l-.002.001zm1.142 4.909a12.39 12.39 0 00-1.638.27c.255-.51.492-1.028.69-1.507l.21.264.01.012c.235.297.5.63.774.957l-.046.004zm3.38 1.189c.003-.005.003-.013-.008-.031-.091-.159-.55-.432-1.685-.487.418.371.77.58 1.07.635.074.014.146.02.213.02.241 0 .38-.084.41-.137z" clipRule="evenodd" ></path>
  </svg>
)

export const FileDocumentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <g
      stroke="#6B7C93"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 6H38L50 18V48A6 6 0 0144 54H20A6 6 0 0114 48V12A6 6 0 0120 6Z" />
      <path d="M38 6V18H50" />
      <path d="M24 22H31" />
      <path d="M24 31H40" />
      <path d="M24 40H40" />
    </g>
  </svg>
)

export const ExcelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" >
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M12.875 3H6.75c-.464 0-.91.19-1.237.527A1.826 1.826 0 005 4.8v14.4c0 .477.184.935.513 1.273.328.337.773.527 1.237.527h10.5c.464 0 .91-.19 1.237-.527.329-.338.513-.796.513-1.273V9.3L12.875 3z" ></path> <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M13 3v6h6" ></path> <path fill="#677A8E" d="M6.393 16.637c0-.16.04-.273.123-.337a.476.476 0 01.304-.1c.12 0 .221.033.305.1.086.064.129.177.129.337 0 .156-.043.27-.129.34a.468.468 0 01-.305.102.468.468 0 01-.304-.102c-.082-.07-.123-.184-.123-.34zm3.641-3.384c-.205 0-.388.037-.55.111-.16.074-.296.182-.408.322a1.455 1.455 0 00-.255.507c-.058.198-.088.42-.088.668 0 .332.047.618.141.859.094.238.236.422.428.55.191.128.433.19.726.19.182 0 .359-.017.53-.052.172-.035.35-.083.534-.143v.597c-.174.069-.35.119-.527.15a3.582 3.582 0 01-.616.047c-.437 0-.8-.091-1.09-.273a1.663 1.663 0 01-.644-.767c-.14-.33-.211-.717-.211-1.16 0-.325.045-.622.135-.891.09-.27.22-.502.392-.697a1.7 1.7 0 01.636-.455c.254-.107.544-.16.87-.16.215 0 .426.024.633.072.209.047.402.115.58.203l-.246.58a3.604 3.604 0 00-.466-.182 1.675 1.675 0 00-.504-.076zm4.45 2.581c0 .254-.062.473-.187.656-.123.184-.3.325-.533.422a2.11 2.11 0 01-.826.147c-.157 0-.306-.01-.449-.027a3.096 3.096 0 01-.404-.076 2.205 2.205 0 01-.343-.126v-.662a4.8 4.8 0 00.583.208c.215.06.434.09.656.09.182 0 .332-.023.452-.07a.565.565 0 00.27-.205.56.56 0 00.087-.313.509.509 0 00-.102-.322.933.933 0 00-.311-.24 5.206 5.206 0 00-.516-.238 3.504 3.504 0 01-.404-.193 1.649 1.649 0 01-.34-.255 1.102 1.102 0 01-.237-.346 1.218 1.218 0 01-.085-.474c0-.243.057-.45.173-.622.117-.171.281-.303.492-.395.213-.092.46-.138.744-.138.225 0 .436.024.633.07.2.048.394.114.586.2l-.223.565a3.978 3.978 0 00-.512-.173 1.98 1.98 0 00-.504-.064.948.948 0 00-.378.067.528.528 0 00-.238.19.51.51 0 00-.079.288c0 .125.03.23.091.316a.87.87 0 00.287.232c.131.07.299.148.504.234.236.098.437.2.6.308.167.107.294.236.381.386.088.149.132.335.132.56zm4.002-3.117L16.99 17h-.744l-1.497-4.283h.72l.903 2.683c.027.079.057.173.088.285.033.11.064.223.09.336.03.114.053.214.068.302.016-.088.037-.188.065-.302.029-.113.06-.225.09-.336.032-.112.061-.208.088-.287l.906-2.681h.72z" ></path>
  </svg>

)

export const EnableIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M24.333 15.233V16a8.334 8.334 0 11-4.941-7.616"
    ></path>
    <path
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M24.333 9.334L16 17.675l-2.5-2.5"
    ></path>
  </svg>)

export const ProfileIcon = () => (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.6663 17.5V15.8333C16.6663 14.9493 16.3152 14.1014 15.69 13.4763C15.0649 12.8512 14.2171 12.5 13.333 12.5H6.66634C5.78229 12.5 4.93444 12.8512 4.30932 13.4763C3.6842 14.1014 3.33301 14.9493 3.33301 15.8333V17.5M13.3337 5.83333C13.3337 7.67428 11.8413 9.16667 10.0003 9.16667C8.15938 9.16667 6.66699 7.67428 6.66699 5.83333C6.66699 3.99238 8.15938 2.5 10.0003 2.5C11.8413 2.5 13.3337 3.99238 13.3337 5.83333Z" stroke="#5473E3" strokeLinecap="round" strokeLinejoin="round" />
</svg>
)

export const CountryIcon = () => (<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.5003 18.3337C15.1027 18.3337 18.8337 14.6027 18.8337 10.0003C18.8337 5.39795 15.1027 1.66699 10.5003 1.66699C5.89795 1.66699 2.16699 5.39795 2.16699 10.0003C2.16699 14.6027 5.89795 18.3337 10.5003 18.3337Z" stroke="#37C2CC" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M2.16699 10H18.8337" stroke="#37C2CC" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M13.8337 10.0003C13.7693 6.91035 12.5847 3.94895 10.5003 1.66699C8.41593 3.94895 7.23136 6.91035 7.16699 10.0003C7.23136 13.0903 8.41593 16.0517 10.5003 18.3337C12.5847 16.0517 13.7693 13.0903 13.8337 10.0003Z" stroke="#37C2CC" strokeLinecap="round" strokeLinejoin="round" />
</svg>)


export const EditProfilePicIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" >
    <rect width="40" height="40" fill="#5473E3" rx="6"></rect>
    <path stroke="#F7F7F7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19.446 12.108h-6.958a1.988 1.988 0 00-1.988 1.989v13.915A1.987 1.987 0 0012.488 30h13.916a1.988 1.988 0 001.988-1.988v-6.958M26.9 10.618a2.108 2.108 0 112.981 2.982l-9.442 9.442-3.976.994.994-3.976 9.443-9.442z" ></path>
  </svg>)

export const DeleteProfilePicIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" >
    <path stroke="#F7F7F7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11.446 4.109H4.488A1.988 1.988 0 002.5 6.096v13.916A1.988 1.988 0 004.488 22h13.916a1.988 1.988 0 001.988-1.988v-6.958M18.9 2.618a2.109 2.109 0 012.981 2.981l-9.442 9.443-3.976.994.994-3.976L18.9 2.618z" ></path>
  </svg>
)

export const GlobalLoader = () => (<div>
  <svg aria-hidden="true" className="inline w-16 h-16 mr-2 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
  </svg>
  <span className="sr-only">Loading...</span>
</div>)


export const UserStatusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path stroke="#37C2CC" strokeLinecap="round" strokeLinejoin="round" d="M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666z"></path>
    <path stroke="#37C2CC" strokeLinecap="round" strokeLinejoin="round" d="M13.334 13.75v-.833a1.666 1.666 0 00-1.667-1.667H8.334a1.667 1.667 0 00-1.667 1.667v.833M10 9.583a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333z"></path>
  </svg>
)

export const NoImg = _ => <svg xmlns="http://www.w3.org/2000/svg" width={96} height={96} style={{ shapeRendering: "geometricPrecision", textRendering: "geometricPrecision", imageRendering: "optimizeQuality", fillRule: "evenodd", clipRule: "evenodd" }}{..._}>
  <path style={{ opacity: .991 }} fill="#de2b38" d="M16.5 11.5a916.679 916.679 0 0 0 36 36c10 10.667 20.333 21 31 31 3.817 1.946 5.65 4.946 5.5 9-1.466 1.825-3.3 2.325-5.5 1.5a38.44 38.44 0 0 1-5-5.5c-9.333-10-19-19.667-29-29-.333-1-1-1.667-2-2-5-5.667-10.333-11-16-16-6.333-7-13-13.667-20-20-3.817-1.946-5.65-4.946-5.5-9C7.466 5.675 9.3 5.175 11.5 6a38.44 38.44 0 0 1 5 5.5Z" />
  <path style={{ opacity: .998 }} fill="#50e5fe" d="M16.5 11.5c22.002-.167 44.002 0 66 .5a696.42 696.42 0 0 1 1 52.5 641.918 641.918 0 0 0-22-20.5c-3.632-.52-6.632.647-9 3.5a916.679 916.679 0 0 1-36-36Z" />
  <path style={{ opacity: 1 }} fill="#50e5fe" d="M11.5 16.5c7 6.333 13.667 13 20 20a134.644 134.644 0 0 1-20 19v-39Z" />
  <path style={{ opacity: 1 }} fill="#fbf7de" d="M57.5 21.5c6.714-.45 9.88 2.55 9.5 9-4.422 6.56-8.755 6.56-13 0-.667-1.667-.667-3.333 0-5a19.568 19.568 0 0 0 3.5-4Z" />
  <path style={{ opacity: 1 }} fill="#1fa2e4" d="M31.5 36.5c5.667 5 11 10.333 16 16-2 2.667-4.333 5-7 7-9.486-.994-19.152-1.327-29-1v-3a134.644 134.644 0 0 0 20-19Z" />
  <path style={{ opacity: 1 }} fill="#26a8e7" d="M83.5 64.5v14c-10.667-10-21-20.333-31-31 2.368-2.853 5.368-4.02 9-3.5a641.918 641.918 0 0 1 22 20.5Z" />
  <path style={{ opacity: 1 }} fill="#32bcef" d="M47.5 52.5c1 .333 1.667 1 2 2v29h-33a407.449 407.449 0 0 1 24-24c2.667-2 5-4.333 7-7Z" />
  <path style={{ opacity: 1 }} fill="#2aafea" d="M49.5 54.5c10 9.333 19.667 19 29 29h-29v-29Z" />
  <path style={{ opacity: 1 }} fill="#1494df" d="M11.5 58.5c9.848-.327 19.514.006 29 1a407.449 407.449 0 0 0-24 24c-1.644.213-3.144-.12-4.5-1-.5-7.993-.666-15.993-.5-24Z" />
</svg>;


export const ProfileImg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    width={30}
    height={30}
    {...props}
  >
    <image
      xlinkHref="data:image/png;base64,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"
      width={30}
      height={30}
    />
  </svg>
)

export const SettingsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    fill="none"
    viewBox="1 1 26 26"
    {...props}
  >
    <circle
      cx="13"
      cy="13"
      r="3.273"
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></circle>
    <path
      fillRule="evenodd"
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.073 16.273a1.8 1.8 0 00.36 1.985l.065.066a2.182 2.182 0 11-3.087 3.087l-.066-.066a1.8 1.8 0 00-1.985-.36 1.8 1.8 0 00-1.09 1.648v.185a2.182 2.182 0 11-4.364 0v-.098a1.8 1.8 0 00-1.179-1.647 1.8 1.8 0 00-1.985.36l-.066.065a2.182 2.182 0 11-3.087-3.087l.066-.066a1.8 1.8 0 00.36-1.985 1.8 1.8 0 00-1.648-1.09h-.185a2.182 2.182 0 110-4.364h.098a1.8 1.8 0 001.647-1.179 1.8 1.8 0 00-.36-1.985l-.065-.066A2.182 2.182 0 117.589 4.59l.066.066a1.8 1.8 0 001.985.36h.087a1.8 1.8 0 001.091-1.648v-.185a2.182 2.182 0 114.364 0v.098a1.8 1.8 0 001.09 1.647 1.8 1.8 0 001.986-.36l.066-.065a2.182 2.182 0 113.087 3.087l-.066.066a1.8 1.8 0 00-.36 1.985v.087a1.8 1.8 0 001.648 1.091h.185a2.182 2.182 0 110 4.364h-.098a1.8 1.8 0 00-1.647 1.09z"
      clipRule="evenodd"
    ></path>
  </svg>
)

export const OutlinedInfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#clip0_1163_14662)"
    >
      <path d="M8 14.667A6.667 6.667 0 108 1.334a6.667 6.667 0 000 13.333zM8 10.667V8M8 5.333h.007"></path>
    </g>
    <defs>
      <clipPath id="clip0_1163_14662">
        <path fill="#fff" d="M0 0H16V16H0z"></path>
      </clipPath>
    </defs>
  </svg>
)

export const AvatarSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={45}
    fill="none"
    {...props}
  >
    <rect width={44} height={44} y={0.5} fill="#C8D3DE" rx={22} />
    <path
      fill="#fff"
      d="M28.857 15.75c0 3.728-3.07 6.75-6.857 6.75-3.788 0-6.857-3.022-6.857-6.75S18.213 9 22 9c3.788 0 6.857 3.022 6.857 6.75Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M25.905 24.188h.895c3.975 0 7.2 3.174 7.2 7.087v2.194C34 34.866 32.848 36 31.429 36H12.57C11.151 36 10 34.866 10 33.469v-2.194c0-3.913 3.225-7.087 7.2-7.087h.895c.363 0 .846.265 1.404.571.764.42 1.67.918 2.602.918 1.449 0 2.413-.661 3.057-1.102.323-.222.565-.387.747-.387Zm-7.838.694 1.873 8.509 1.44-5.318L20.3 26.3l-2.233-1.418Zm4.754 3.191 1.44 5.318 1.873-8.509-2.232 1.418-1.08 1.773Z"
      clipRule="evenodd"
    />
  </svg>
)

export const HorizontalLoader = () => (<svg
  xmlns='http://www.w3.org/2000/svg'
  width='32'
  height='4'
  version='1'
  viewBox='0 0 128 16'
>
  <rect width='100%' height='100%' fill='#FFF'></rect>
  <path
    fill='#afb3f5'
    d='M6.4 4.8A3.2 3.2 0 113.2 8a3.2 3.2 0 013.2-3.2zm12.8 0A3.2 3.2 0 1116 8a3.2 3.2 0 013.2-3.2zm12.8 0A3.2 3.2 0 1128.8 8 3.2 3.2 0 0132 4.8zm12.8 0A3.2 3.2 0 1141.6 8a3.2 3.2 0 013.2-3.2zm12.8 0A3.2 3.2 0 1154.4 8a3.2 3.2 0 013.2-3.2zm12.8 0A3.2 3.2 0 1167.2 8a3.2 3.2 0 013.2-3.2zm12.8 0A3.2 3.2 0 1180 8a3.2 3.2 0 013.2-3.2zm12.8 0A3.2 3.2 0 1192.8 8 3.2 3.2 0 0196 4.8zm12.8 0a3.2 3.2 0 11-3.2 3.2 3.2 3.2 0 013.2-3.2zm12.8 0a3.2 3.2 0 11-3.2 3.2 3.2 3.2 0 013.2-3.2z'
  ></path>
  <g>
    <path
      fill='#404ae7'
      d='M-42.7 3.84A4.16 4.16 0 01-38.54 8a4.16 4.16 0 01-4.16 4.16A4.16 4.16 0 01-46.86 8a4.16 4.16 0 014.16-4.16zm12.8-.64A4.8 4.8 0 01-25.1 8a4.8 4.8 0 01-4.8 4.8A4.8 4.8 0 01-34.7 8a4.8 4.8 0 014.8-4.8zm12.8-.64A5.44 5.44 0 01-11.66 8a5.44 5.44 0 01-5.44 5.44A5.44 5.44 0 01-22.54 8a5.44 5.44 0 015.44-5.44z'
    ></path>
    <animateTransform
      attributeName='transform'
      calcMode='discrete'
      dur='1170ms'
      repeatCount='indefinite'
      type='translate'
      values='23 0;36 0;49 0;62 0;74.5 0;87.5 0;100 0;113 0;125.5 0;138.5 0;151.5 0;164.5 0;178 0'
    ></animateTransform>
  </g>
</svg>)

export const HistoryIcon = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" >
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666z" ></path>
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M10 5v5l3.333 1.667" ></path>
  </svg>)
}

export const BackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" >
    <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M15.834 10H4.167m0 0L10 15.833M4.167 10L10 4.167" ></path>
  </svg>
)


export const ReSyncIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" >
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M14.167.833L17.5 4.167 14.167 7.5" ></path>
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M2.5 9.167V7.5a3.333 3.333 0 013.333-3.333H17.5M5.833 19.167L2.5 15.833 5.833 12.5" ></path>
    <path stroke="#677A8E" strokeLinecap="round" strokeLinejoin="round" d="M17.5 10.833V12.5a3.334 3.334 0 01-3.333 3.333H2.5" ></path>
  </svg>
)

export const ChevronDownArrow = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 20.166a9.167 9.167 0 100-18.333 9.167 9.167 0 000 18.333z"
    ></path>
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.333 11L11 14.667 14.666 11M11 7.333v7.333"
    ></path>
  </svg>

)
export const RoleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#37C2CC"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666z"
      ></path>
      <g clipPath="url(#clip0_4988_45165)">
        <path
          stroke="#37C2CC"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12.334 13.75v-.833a1.666 1.666 0 00-1.667-1.667H7.334a1.667 1.667 0 00-1.667 1.667v.833M9 9.583A1.667 1.667 0 109 6.25a1.667 1.667 0 000 3.333z"
        ></path>
        <path
          fill="#37C2CC"
          d="M12.144 8.642l2.091 2.068a.418.418 0 00.589-.596L13.192 8.5l1.632-1.615a.418.418 0 00-.589-.595l-2.091 2.068a.2.2 0 000 .284z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4988_45165">
          <path fill="#fff" d="M0 0H10V10H0z" transform="translate(5 5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export const BlueInfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <g
        stroke="#5473E3"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#clip0_425_29372)"
      >
        <path d="M7 12.833A5.833 5.833 0 107 1.166a5.833 5.833 0 000 11.667zM7 9.333V7M7 4.667h.006"></path>
      </g>
      <defs>
        <clipPath id="clip0_425_29372">
          <path fill="#fff" d="M0 0H14V14H0z"></path>
        </clipPath>
      </defs>
    </svg>)
}



export const EditPencilIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="33"
  height="32"
  fill="none"
  viewBox="0 0 33 32"
>
  <rect width="32.002" height="32" fill="#EDF3FF" rx="6"></rect>
  <path
    stroke="#5473E3"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M16.001 22.667h7.5M21.001 8.398c-.469 0-.919.187-1.25.518L9.334 19.333l-.833 3.333 3.333-.833 10.417-10.417a1.769 1.769 0 00-1.25-3.018z"
  ></path>
</svg>)

export const PencilIconBlue = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || "16"}
      height={props?.height || "16"}
      fill="none"
      viewBox={props?.viewBox || "0 0 16 16"}
    >
      <path
        stroke="#5473E3"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 13.334h6M12 1.919c-.375 0-.735.149-1 .414l-8.333 8.333L2 13.333l2.667-.667L13 4.333a1.415 1.415 0 00-1-2.414z"
      ></path>
    </svg>)
}

export const DownArrow = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="12"
  fill="none"
  viewBox="0 0 12 12"
>
  <path
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M6 11V1M1 6l5-5 5 5"
  ></path>
</svg>)

export const ChevDown = (props) => {
  return (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    {...props}
    height="5"
    fill="none"
    viewBox="0 0 10 5"
  >
    <path
      fill="#2D2F32"
      fillRule="evenodd"
      d="M.208 0l4.896 5L10 0H0"
      clipRule="evenodd"
    ></path>
  </svg>)
}


export const LinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#FCAF68"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 17L17 7M7 7h10v10"
      ></path>
    </svg>
  );
}
export const RefreshIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"

      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M23 4v6h-6M1 20v-6h6"></path>
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
    </svg>
  );
}

export const InviteAgainButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        stroke="#5473E3"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.167.833L17.5 4.167 14.167 7.5"
      ></path>
      <path
        stroke="#5473E3"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.5 9.167V7.5a3.333 3.333 0 013.333-3.333H17.5M5.833 19.167L2.5 15.833 5.833 12.5"
      ></path>
      <path
        stroke="#5473E3"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.5 10.833V12.5a3.334 3.334 0 01-3.333 3.333H2.5"
      ></path>
    </svg>
  );
};


export const AttachIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={28}
    transform="scale(0.6)"
    fill="none"
    {...props}
  >
    <path
      stroke="#677A8E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m20.44 11.05-9.19 9.19a6.003 6.003 0 1 1-8.49-8.49l9.19-9.19a4.002 4.002 0 0 1 5.66 5.66l-9.2 9.19a2.001 2.001 0 1 1-2.83-2.83l8.49-8.48"
    />
  </svg>
)

export const PDFIcon = (props) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} {...props}>
    <path
      fill="#e53935"
      d="M38 42H10a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4z"
    />
    <path
      fill="#fff"
      d="M34.841 26.799c-1.692-1.757-6.314-1.041-7.42-.911-1.627-1.562-2.734-3.45-3.124-4.101.586-1.757.976-3.515 1.041-5.402 0-1.627-.651-3.385-2.473-3.385-.651 0-1.237.391-1.562.911-.781 1.367-.456 4.101.781 6.899-.716 2.018-1.367 3.97-3.189 7.42-1.888.781-5.858 2.604-6.183 4.556-.13.586.065 1.172.521 1.627.455.392 1.04.587 1.626.587 2.408 0 4.751-3.32 6.379-6.118 1.367-.456 3.515-1.107 5.663-1.497 2.538 2.213 4.751 2.538 5.923 2.538 1.562 0 2.148-.651 2.343-1.237.325-.65.13-1.366-.326-1.887zm-1.627 1.106c-.065.456-.651.911-1.692.651a8.925 8.925 0 0 1-3.32-1.692c.846-.13 2.734-.325 4.101-.065.521.13 1.041.455.911 1.106zm-10.87-13.408c.13-.195.325-.325.521-.325.586 0 .716.716.716 1.302a14.291 14.291 0 0 1-.781 4.036c-.976-2.605-.781-4.427-.456-5.013zm-.13 12.627c.521-1.041 1.237-2.864 1.497-3.645.586.976 1.562 2.148 2.083 2.669 0 .065-2.018.456-3.58.976zm-3.84 2.604c-1.497 2.473-3.059 4.036-3.905 4.036-.13 0-.26-.065-.391-.13-.195-.13-.26-.325-.195-.586.195-.912 1.887-2.149 4.491-3.32z"
    />
  </svg>)
}

export const ExcelFileIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} {...props}>
    <path fill="#21a366" d="M28 15h16v9H28z" />
    <path fill="#185c37" d="M44 24H12v16a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V24z" />
    <path fill="#107c42" d="M28 24h16v9H28z" />
    <path fill="#3fa071" d="M12 15h16v9H12z" />
    <path fill="#33c481" d="M42 6H28v9h16V8a2 2 0 0 0-2-2z" />
    <path fill="#21a366" d="M14 6h14v9H12V8a2 2 0 0 1 2-2z" />
    <path
      d="M22.319 13H12v24h10.319A3.68 3.68 0 0 0 26 33.319V16.681A3.68 3.68 0 0 0 22.319 13z"
      opacity={0.05}
    />
    <path
      d="M22.213 36H12V13.333h10.213a3.12 3.12 0 0 1 3.121 3.121v16.425A3.122 3.122 0 0 1 22.213 36z"
      opacity={0.07}
    />
    <path
      d="M22.106 35H12V13.667h10.106a2.56 2.56 0 0 1 2.56 2.56V32.44a2.56 2.56 0 0 1-2.56 2.56z"
      opacity={0.09}
    />
    <linearGradient
      id="a"
      x1={4.725}
      x2={23.055}
      y1={14.725}
      y2={33.055}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#18884f" />
      <stop offset={1} stopColor="#0b6731" />
    </linearGradient>
    <path
      fill="url(#a)"
      d="M22 34H6a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z"
    />
    <path
      fill="#fff"
      d="M9.807 19h2.386l1.936 3.754L16.175 19h2.229l-3.071 5 3.141 5h-2.351l-2.11-3.93L11.912 29H9.526l3.193-5.018L9.807 19z"
    />
  </svg>)

export const DocIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} {...props}>
    <path
      fill="#2196f3"
      d="M37 45H11a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h19l10 10v29a3 3 0 0 1-3 3z"
    />
    <path fill="#bbdefb" d="M40 13H30V3z" />
    <path fill="#1565c0" d="m30 13 10 10V13z" />
    <path
      fill="#e3f2fd"
      d="M15 23h18v2H15zm0 4h18v2H15zm0 4h18v2H15zm0 4h10v2H15z"
    />
  </svg>
)
export const TextFileIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} {...props}>
    <path fill="#90CAF9" d="M40 45H8V3h22l10 10z" />
    <path fill="#E1F5FE" d="M38.5 14H29V4.5z" />
  </svg>
)
export const HelpPrimaryIcon = () => {
  return (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 18.335a8.333 8.333 0 100-16.667 8.333 8.333 0 000 16.667z"
    ></path>
    <path
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.575 7.499a2.5 2.5 0 014.859.833c0 1.667-2.5 2.5-2.5 2.5M10 14.168h.008"
    ></path>
  </svg>)
}

export const DBIconWhite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="#677A8E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 8c4.97 0 9-1.343 9-3s-4.03-3-9-3-9 1.343-9 3 4.03 3 9 3zM21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
      ></path>
      <path
        stroke="#677A8E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
      ></path>
    </svg>
  );
}

export const DBIconBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#677A8E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 6.667c4.142 0 7.5-1.12 7.5-2.5 0-1.381-3.358-2.5-7.5-2.5-4.142 0-7.5 1.119-7.5 2.5 0 1.38 3.358 2.5 7.5 2.5zM17.5 10c0 1.383-3.333 2.5-7.5 2.5S2.5 11.383 2.5 10"
      ></path>
      <path
        stroke="#677A8E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.5 4.167v11.666c0 1.384 3.333 2.5 7.5 2.5s7.5-1.116 7.5-2.5V4.167"
      ></path>
    </svg>
  );
}
export const MoreIcon = (props) => {
  return (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      stroke="#5473E3"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 6.5a.5.5 0 100-1 .5.5 0 000 1zM6 3a.5.5 0 100-1 .5.5 0 000 1zM6 10a.5.5 0 100-1 .5.5 0 000 1z"     {...props}
    ></path>
  </svg>)
}

export const BlackBorderedEditIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    stroke="#394657"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M9.167 3.333H3.333A1.667 1.667 0 001.667 5v11.666a1.667 1.667 0 001.666 1.667H15a1.667 1.667 0 001.667-1.667v-5.833"
  ></path>
  <path
    stroke="#394657"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M16.667 1.565c-.47 0-.919.187-1.25.518L7.5 10l-.833 3.333L10 12.5l7.917-7.917a1.767 1.767 0 00-1.25-3.018z"
  ></path>
</svg>)
export const BlackCloneIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    stroke="#394657"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M16.667 7.5h-7.5c-.92 0-1.667.746-1.667 1.667v7.5c0 .92.746 1.666 1.667 1.666h7.5c.92 0 1.666-.746 1.666-1.666v-7.5c0-.92-.746-1.667-1.666-1.667z"
  ></path>
  <path
    stroke="#394657"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M4.167 12.5h-.834a1.667 1.667 0 01-1.666-1.666v-7.5a1.667 1.667 0 011.666-1.667h7.5A1.667 1.667 0 0112.5 3.334v.833"
  ></path>
</svg>)
export const BlackShareIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    stroke="#394657"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M15 6.667a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM5 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM15 18.333a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM7.158 11.259l5.692 3.316M12.842 5.425L7.158 8.74"
  ></path>
</svg>)

export const TrelloIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="22"
  height="22"
  fill="none"
  viewBox="0 0 22 22"
>
  <path
    stroke="#0B8F77"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M16.88 3.44H5.12a1.68 1.68 0 00-1.68 1.68v11.76c0 .927.752 1.68 1.68 1.68h11.76a1.68 1.68 0 001.68-1.68V5.12a1.68 1.68 0 00-1.68-1.68z"
  ></path>
  <path
    stroke="#0B8F77"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M9.32 6.8H6.8v7.56h2.52V6.8zM15.2 6.8h-2.52V11h2.52V6.8z"
  ></path>
</svg>)

export const RightChevron = (props) => (<svg {...props}
  xmlns="http://www.w3.org/2000/svg"
  width="8"
  height="14"
  fill="none"
  viewBox="0 0 8 14"
>
  <path
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M1 13l6-6-6-6"
  ></path>
</svg>)

export const LeftChevron = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="8"
  height="14"
  fill="none"
  viewBox="0 0 8 14"
>
  <path
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M7 13L1 7l6-6"
  ></path>
</svg>)

export const AddPlusIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#fff"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8v8M8 12h8"
  ></path>
</svg>)

export const ManIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="14"
  height="14"
  fill="none"
  viewBox="0 0 14 14"
>
  <path
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M11.667 12.25v-1.167A2.333 2.333 0 009.334 8.75H4.667a2.333 2.333 0 00-2.333 2.333v1.167M7 6.417A2.333 2.333 0 107 1.75a2.333 2.333 0 000 4.667z"
  ></path>
</svg>)

export const NormalMonitorIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M20 3H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V5a2 2 0 00-2-2zM8 21h8M12 17v4"
  ></path>
</svg>)

export const ActiveMonitorIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  fill="none"
  viewBox="0 0 24 24"
>
  <path
    stroke="#677A8E"
    d="M20 3H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V5a2 2 0 00-2-2zM8 21h8m-4-4v4"
  ></path>
</svg>)


export const DragIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
  <g
    stroke="#677A8E"
    strokeLinecap="round"
    strokeLinejoin="round"
    clipPath="url(#clip0_575_8690)"
  >
    <path d="M3.333 6l-2 2 2 2M6 3.333l2-2 2 2M10 12.667l-2 2-2-2M12.667 6l2 2-2 2M1.333 8h13.334M8 1.333v13.334"></path>
  </g>
  <defs>
    <clipPath id="clip0_575_8690">
      <path fill="#fff" d="M0 0h16v16H0z"></path>
    </clipPath>
  </defs>
</svg>)

export const CalendarSettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      stroke="#A3B3C8"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 4.5H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-14a2 2 0 00-2-2zM16 2.5v4M8 2.5v4M3 10.5h18"
    ></path>
  </svg>
)
export const SendIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  viewBox="0 0 20 20"
>
  <path
    stroke="#5473E3"
    strokeLinecap="round"
    strokeLinejoin="round"
    d="M18.334 1.667l-9.166 9.166M12.501 18.333l5.833-16.666L1.668 7.5l7.5 3.333 3.333 7.5z"
  ></path>
</svg>)

export const LogoPrintIcon = () => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="92"
  height="44"
  fill="none"
  viewBox="0 0 92 44"
>
  <mask
    id="mask0_152_8217"
    style={{ maskType: "luminance" }}
    width="92"
    height="44"
    x="0"
    y="0"
    maskUnits="userSpaceOnUse"
  >
    <path fill="#fff" d="M91.632 0H0v43.525h91.632V0z"></path>
  </mask>
  <g fill="#AA00EA" mask="url(#mask0_152_8217)">
    <path d="M36.393 20.613a3.27 3.27 0 11-6.538 0 3.27 3.27 0 116.538 0zM86.067 3.274a3.27 3.27 0 11-6.539 0 3.27 3.27 0 116.539 0zM62.431 11.524a3.27 3.27 0 11-6.538 0 3.27 3.27 0 116.538 0zM75.872 43.186v-2.518h-2.679v2.518H71.63v-6.369h1.564v2.479h2.679v-2.479h1.554v6.369h-1.554zM80.56 40.998h-.456v2.188H78.54v-6.369h3.216c1.376 0 2.286.84 2.286 2.081 0 1.048-.644 1.795-1.67 2.023l1.99 2.26h-1.89l-1.917-2.188.005.005zm1.947-2.08c0-.456-.359-.762-.92-.762h-1.483v1.528h1.483c.561 0 .92-.306.92-.771M46.947 17.334c-4.98 0-9.072 3.687-9.072 9.085 0 5.398 4.093 9.084 9.038 9.084 3.923 0 7.023-1.741 8.49-5.36l-4.843-.989c-.92 1.674-2.388 1.98-3.647 1.98-1.84 0-3.24-1.267-3.681-3.314H55.78V26.42c-.102-5.597-3.991-9.085-8.83-9.085m-3.613 7.135c.514-1.741 2.083-2.697 3.614-2.697 1.53 0 2.934.854 3.443 2.697h-7.057z"></path>
    <path d="M80.143 17.849V12.11h5.454v5.738h5.047v4.335h-5.047v5.942c0 1.775.853 2.493 2.286 2.493.75 0 1.773-.272 2.49-.684l1.264 4.302c-1.332.718-2.727 1.261-4.674 1.261-4.262 0-6.82-2.323-6.82-6.829v-6.49h-5.298l-9.062 21.002h-5.866l3.788-8.774-7.076-16.563h5.865l4.044 9.971 4.316-9.971h9.29v.005zM22.73 34.989h5.458V17.848H22.73v17.14zM13.673 19.216c-1.327-1.193-3.105-1.877-5.318-1.877C3.82 17.334 0 21.026 0 26.42c0 5.393 3.821 9.084 8.355 9.084 2.218 0 3.99-.684 5.318-1.877v1.16c0 2.696-2.146 3.928-4.601 3.928-1.773 0-2.761-.582-4.025-2.115L.513 39.398c1.671 2.764 4.635 4.132 8.559 4.132 5.56 0 10.06-2.9 10.06-8.197V17.85h-5.46v1.367zm-4.16 10.482a3.27 3.27 0 01-3.27-3.274 3.27 3.27 0 116.539 0 3.27 3.27 0 01-3.27 3.274z"></path>
  </g>
</svg>)

export const HelpIcon = (props) => (<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  fill="none"
  stroke="#677A8E"
  strokeLinecap="round"
  strokeLinejoin="round"
  className="feather feather-help-circle"
  viewBox="0 0 24 24" {...props}
>
  <circle cx="12" cy="12" r="10"></circle>
  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01"></path>
</svg>)

export const PaperClipIcon = (props) => (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6" {...props}>
  <path strokeLinecap="round" strokeLinejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
</svg>)
